<template>
  <div class="page" v-loading="loading">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>订单</el-breadcrumb-item>
        <el-breadcrumb-item>预处理订单</el-breadcrumb-item>
        <el-breadcrumb-item>货品订单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-row>
      <el-col :span="16">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-select size="mini" v-model="filter.store_id" value-key="" filterable placeholder="选择店铺">
              <el-option label="所有店铺" value=""></el-option>
              <el-option v-for="store in stores" :key="store.id" :label="store.title" :value="store.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select size="mini" v-model="filter.time_type" style="width: 120px">
              <el-option label="下单时间" value="created_at"></el-option>
              <el-option label="尾款支付时间" value="payed_at"></el-option>
              <el-option label="定金支付时间" value="front_payment_time"></el-option>
              <el-option label="收货时间" value="kd_adminer_time"></el-option>
              <el-option label="预处理时间" value="pretreatment_time"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              size="mini"
              v-model="filter.date_range"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="filter.keyword"
              placeholder="搜索订单号 / 昵称 / 手机号 / 核销码 / 卡号 / 姓名"
              size="mini"
              clearable
              style="width: 300px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select size="mini" v-model="filter.price_type" value-key="" clearable filterable placeholder=" 订单价格类型">
              <el-option label="一元订单" value="1"> </el-option>
              <el-option label="全款订单" value="2"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select size="mini" v-model="filter.sort_type" clearable placeholder="排序选择" style="width: 120px">
              <el-option label="订单创建时间" value="1"></el-option>
              <el-option label="星级" value="2"></el-option>
              <el-option label="预处理时间" value="3"></el-option>
              <el-option label="预约提交时间" value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select
              size="mini"
              v-model="filter.province"
              value-key=""
              clearable
              filterable
              placeholder="选择省份"
              @change="getCities(2)"
            >
              <el-option
                v-for="province in provinces"
                :key="province.code"
                :label="province.name"
                :value="province.code"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select size="mini" v-model="filter.city_code" value-key="" clearable filterable placeholder="选择城市">
              <el-option v-for="city in cities" :key="city.code" :label="city.name" :value="city.code"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="onSearch" size="mini">查询</el-button>
            <el-button icon="el-icon-refresh" type="success" size="mini" @click="onRefresh">刷新</el-button>
          </el-form-item>
          <el-form-item>
            <el-checkbox-group v-model="filter.status" size="mini">
              <el-checkbox :label="0">待付款</el-checkbox>
              <el-checkbox :label="11">付定金</el-checkbox>
              <el-checkbox :label="1">已付款</el-checkbox>
              <el-checkbox :label="2">已开卡</el-checkbox>
              <el-checkbox :label="3">已发货</el-checkbox>
              <el-checkbox :label="4">已完成</el-checkbox>
              <el-checkbox :label="5">退款中</el-checkbox>
              <el-checkbox :label="6">已退款</el-checkbox>
              <el-checkbox :label="7">已取消</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-tabs v-model="actTableType" type="card" @tab-click="changeTab">
      <el-tab-pane :label="'全部(' + totalData.all_count + ')'" name="-1"></el-tab-pane>
      <el-tab-pane :label="'待付款(' + totalData.unpay + ')'" name="0"></el-tab-pane>
      <el-tab-pane :label="'付定金(' + totalData.deposit + ')'" name="11"></el-tab-pane>
      <el-tab-pane :label="'已付款(' + totalData.ispay + ')'" name="1"></el-tab-pane>
      <el-tab-pane :label="'已发卡(' + totalData.sendCard + ')'" name="2"></el-tab-pane>
      <el-tab-pane :label="'已发货(' + totalData.sendgoods + ')'" name="3"></el-tab-pane>
      <el-tab-pane :label="'已完成(' + totalData.isFinish + ')'" name="4"></el-tab-pane>
      <el-tab-pane :label="'退款中(' + totalData.refunding + ')'" name="5"></el-tab-pane>
      <el-tab-pane :label="'已退款(' + totalData.refunded + ')'" name="6"></el-tab-pane>
      <el-tab-pane :label="'已取消(' + totalData.cancel + ')'" name="7"></el-tab-pane>
    </el-tabs>
    <el-tabs v-model="actTableType" @tab-click="changeTab">
      <el-tab-pane :label="'今日待处理(' + tableAll.today_pending + ')'" name="9"></el-tab-pane>
      <el-tab-pane :label="'今日已处理(' + tableAll.today_processed + ')'" name="12"></el-tab-pane>
    </el-tabs>
    <div class="order_table" v-for="(order, i) in tableData" :key="order.id">
      <div class="order">
        <div class="order-header">
          <div class="order-no">
            <span class="index"> #{{ i + 1 }} </span>
            <span>
              <el-tag effect="dark" :color="order.store.platform.color" size="mini">
                {{ order.store.platform.title }}
              </el-tag>
            </span>
            <span>店铺名：{{ order.store.title }}</span>
            <span>订单号：{{ order.order_no }}</span>
          </div>
          <span class="order-create"> 下单时间：{{ order.created_at }} </span>
          <span class="pay-time">
            <span v-if="order.status == 11"> 付定金时间：{{ order.front_payment_time ? order.front_payment_time : '-' }} </span>
          </span>
          <div>
            <span>引导人：</span>
            <span v-if="order.modifications.length > 0">
              {{ order.modifications[0].adminer }}
            </span>
          </div>
          <span style="margin-right: 100px;">操作</span>
        </div>
        <div class="order-body">
          <div class="order-items">
            <div class="order-item" v-for="(orderItem, ind) in order.order_items" :key="ind">
              <div class="good">
                <div class="good-box">
                  <div style="width: 100%; display: flex">
                    <div class="good-img">
                      <el-image :src="orderItem.thumb" fit="fill"></el-image>
                    </div>
                    <div class="good-info">
                      <div class="good-title">【{{ orderItem.good ? orderItem.good.good_no : '' }} 】</div>
                      <div class="good-title">
                        {{ orderItem.title }}
                        <el-tag type="danger" size="mini" style="margin-right: 5px" v-if="orderItem.is_gift == 1">赠送 </el-tag>
                      </div>
                      <div class="order-payment">
                        <div class="payment">
                          <span>销售金额：</span>
                          <span>
                            {{ (parseFloat(orderItem.good.sale_price) + parseFloat(orderItem.pay_balance)).toFixed(2) }} x
                            {{ orderItem.num }}
                          </span>
                        </div>
                        <div class="payment">
                          <span>优惠金额：</span>
                          <span>¥0.00</span>
                        </div>
                        <div class="payment">
                          <span>使用余额：</span>
                          <span>¥{{ order.pay_balance }}</span>
                        </div>
                        <div class="payment">
                          <span style="color: #f90000;">实付金额：</span>
                          <span style="color: #f90000;">¥{{ order.payment }}</span>
                        </div>
                        <span v-if="order.status == 11">
                          <span style="color: rgb(59 64 66)">定金：¥{{ order.front_payment }}</span
                          ><br
                        /></span>
                      </div>
                    </div>
                    <div class="paymentbtn">
                      <el-button
                        v-if="power_change_goods == 1"
                        type="warning"
                        style="padding: 5px;"
                        @click="showItemEditFunc(orderItem, order.payment)"
                        >改套餐</el-button
                      >
                    </div>
                  </div>
                  <div class="membermsg" v-if="orderItem.good && orderItem.good.channels">
                    <div class="member">
                      <div class="member-nickname">客户昵称：{{ order.member ? order.member.nickname : '' }}</div>
                      <div class="member-mobile">电话：{{ order.mobile }}</div>
                      <div>
                        付款状态：<span style="color: #007CFF;">
                          <tableEditSelect propsName="status" :options="orderStatusList" :info="order" url="orders/quick">
                          </tableEditSelect>
                          &nbsp;{{ order.payed_at ? order.payed_at : '-' }}
                        </span>
                      </div>
                      <div>
                        付款方式：
                        <span style="color: #007CFF;">
                          {{ order.pay_type_text ? order.pay_type_text : '' }}
                        </span>
                      </div>
                      <div>
                        付款条件：
                        <span style="color: #007CFF;">
                          {{ order.settlement_type == 0 ? '现结' : '月结' }}
                        </span>
                      </div>
                    </div>
                    <div
                      v-if="orderItem.good && orderItem.good.products && orderItem.good.products.length > 0"
                      style="flex: 1; padding-bottom: 5px; margin-top: 5px;"
                    >
                      <div v-for="product in orderItem.good.products" :key="product.id">
                        <el-dropdown>
                          <span
                            v-if="product.channel_title && product.channel_title.length > 0"
                            class="el-dropdown-link"
                            style="font-size: 12px !important;"
                          >
                            商品渠道：<span>
                              【{{ product.channel_title[0].code ? product.channel_title[0].code : '' }}】{{
                                product.channel_title[0].title ? product.channel_title[0].title : ''
                              }}
                            </span>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <span v-else style="margin-top: 5px; padding-left: 10px;">
                            商品渠道：【】
                          </span>
                          <div v-if="product.channel_title && product.channel_title.length > 0">
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item v-for="channel in product.channel_title" :key="channel.id">
                                【{{ channel.code ? channel.code : '' }}】{{ channel.title ? channel.title : '' }}
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </div>
                          <div v-else style="margin-top: 5px;">
                            <span class="el-dropdown-link" style="font-size: 12px !important; letter-spacing: 2px">
                              商品渠道：【】</span
                            >
                          </div>
                        </el-dropdown>
                      </div>
                    </div>
                    <div v-else style="margin-top: 5px; padding-left: 10px;">
                      <span class="el-dropdown-link" style="font-size: 12px !important; letter-spacing: 2px">
                        商品渠道：【】</span
                      >
                    </div>
                    <div class="btn-bottom">
                      <div class="order-money">
                        <div @click="showRemarks(order.id, order.remark_logs)">
                          <div v-if="order.remark_logs.length > 0">
                            备注：
                            <el-link type="danger" icon="el-icon-s-flag" v-if="order.remark_logs[0].type == 4"> </el-link>
                            <el-link type="primary" icon="el-icon-s-flag" v-if="order.remark_logs[0].type == 3"> </el-link>
                            <el-link type="warning" icon="el-icon-s-flag" v-if="order.remark_logs[0].type == 2"> </el-link>
                            <el-link type="info" icon="el-icon-s-flag" v-if="order.remark_logs[0].type == 1"></el-link>
                          </div>
                          <div v-else>备注：<el-link type="info" icon="el-icon-s-flag"></el-link></div>
                        </div>
                      </div>
                      <el-button type="primary" size="mini" @click="onEdit(order)">编辑 </el-button>
                    </div>
                  </div>
                </div>
                <div class="good-verifies" v-if="orderItem.is_real == 1">
                  <div class="verify" v-for="(verify, index) in orderItem.order_pretreatments" :key="index">
                    <div class="verify-body wrap1">
                      <div>
                        <div>
                          <i class="el-icon-user" style="color: #007CFF;"></i>
                          &nbsp;收件人：
                          <span>{{ order.consignee ? order.consignee : '' }}</span>
                        </div>
                        <div>
                          <i class="el-icon-mobile-phone" style="color: #007CFF"></i>
                          &nbsp;手机号：
                          <span>{{ order.mobile ? order.mobile : '' }}</span>
                        </div>
                        <div>
                          <i class="el-icon-location-outline" style="color: #007CFF"></i>
                          &nbsp;收件地址：
                          <span>{{ order.address ? order.address : '' }}</span>
                        </div>
                        <div>
                          <i class="el-icon-truck" style="color: #007CFF"></i>
                          &nbsp;快递/物流：
                          <span v-if="order.kd_name">{{ order.kd_name }}</span>
                        </div>
                        <div>
                          <i class="el-icon-folder-checked" style="color: #007CFF"></i>
                          &nbsp;快递单号：
                          <span v-if="order.kd_name">{{ order.kd_no }}</span>
                        </div>
                        <div>
                          <i class="el-icon-time" style="color: #007CFF"></i>
                          &nbsp;发货时间：
                          <span v-if="order.kd_name">{{ order.kd_adminer_time }}</span>
                        </div>
                      </div>
                      <div style="float: right; display: flex;">
                        <div v-if="order.kd_name">
                          <el-popover placement="top" width="220" trigger="manual" v-model="order.kdShow">
                            <div slot="reference">
                              <p>
                                <el-tag size="mini" type="primary" effect="dark" @click="order.kdShow = !order.kdShow">
                                  编辑
                                </el-tag>
                              </p>
                            </div>
                            <div>
                              <p v-if="order.kd_adminer">发货人: {{ order.kd_adminer }}</p>
                              <p v-if="order.kd_adminer_time">发货时间: {{ order.kd_adminer_time }}</p>
                            </div>
                            <div class="row-edit-input">
                              <div class="quick-form">
                                <el-select
                                  v-model="order.kd_name"
                                  placeholder="填写快递公司"
                                  size="mini"
                                  clearable
                                  filterable
                                  @change="changeKdName(order)"
                                >
                                  <el-option label="顺丰" value="顺丰"> </el-option>
                                  <el-option label="中通" value="中通"> </el-option>
                                  <el-option label="圆通" value="圆通"> </el-option>
                                  <el-option label="申通" value="申通"> </el-option>
                                  <el-option label="极兔" value="极兔"></el-option>
                                  <el-option label="韵达" value="韵达"></el-option>
                                  <el-option label="京东物流" value="京东物流"></el-option>
                                  <el-option label="德邦物流" value="德邦物流"></el-option>
                                  <el-option label="邮政" value="邮政"></el-option>
                                </el-select>
                              </div>
                              <div class="quick-form">
                                <el-input v-model="order.kd_no" placeholder="填写快递单号" size="mini" clearable></el-input>
                              </div>
                              <div class="quick-form">
                                <el-input v-model="order.kd_fee" placeholder="填写快递费" size="mini" clearable></el-input>
                              </div>
                              <div class="quick-form">
                                <el-input v-model="order.consignee" placeholder="填写收件人" size="mini" clearable></el-input>
                              </div>
                            </div>
                            <div style="text-align: right; margin: 0">
                              <el-button size="mini" type="text" @click="order.kdShow = false">取消</el-button>
                              <el-button type="primary" size="mini" @click="setOrderItemKd(order)">确定</el-button>
                            </div>
                          </el-popover>
                        </div>
                        <div v-else-if="order.status != 0">
                          <el-popover placement="top" width="200" trigger="manual" v-model="order.kdShow">
                            <el-link type="primary" slot="reference" @click="order.kdShow = !order.kdShow">
                              <span style="font-size: 12px"
                                >发货
                                <i class="el-icon-edit"></i>
                              </span>
                            </el-link>
                            <div class="row-edit-input">
                              <div class="quick-form">
                                <el-select
                                  v-model="order.kd_name"
                                  placeholder="填写快递公司"
                                  size="mini"
                                  clearable
                                  filterable
                                  @change="changeKdName(order)"
                                >
                                  <el-option label="顺丰" value="顺丰"> </el-option>
                                  <el-option label="中通" value="中通"> </el-option>
                                  <el-option label="圆通" value="圆通"> </el-option>
                                  <el-option label="申通" value="申通"> </el-option>
                                  <el-option label="极兔" value="极兔"></el-option>
                                  <el-option label="韵达" value="韵达"></el-option>
                                  <el-option label="京东物流" value="京东物流"></el-option>
                                  <el-option label="德邦物流" value="德邦物流"></el-option>
                                  <el-option label="邮政" value="邮政"></el-option>
                                </el-select>
                              </div>
                              <div class="quick-form">
                                <el-input v-model="order.kd_no" placeholder="填写快递单号" size="mini" clearable> </el-input>
                              </div>
                              <div class="quick-form">
                                <el-input v-model="order.kd_fee" placeholder="填写快递费" size="mini" clearable> </el-input>
                              </div>
                              <div class="quick-form">
                                <el-input v-model="order.consignee" placeholder="收件人" size="mini" clearable> </el-input>
                              </div>
                            </div>
                            <div style="text-align: right; margin: 0">
                              <el-button size="mini" type="text" @click="order.kdShow = false">取消</el-button>
                              <el-button type="primary" size="mini" @click="setOrderItemKd(order)">确定 </el-button>
                            </div>
                          </el-popover>
                        </div>
                        <el-button
                          v-if="orderItem.is_self == 1"
                          type="primary"
                          @click="importReportShow(verify.order_item_id, verify, 1)"
                          style="padding: 5px; display: inline-block; height: 25px; margin-top: 18px;"
                          size="mini"
                          icon="el-icon-circle-plus-outline"
                          >上传报告</el-button
                        >
                      </div>
                    </div>
                    <div class="verify-body wrap2">
                      <div>
                        发货状态：<span style="color: #007CFF;">
                          <tableEditSelect
                            propsName="shipping_status"
                            :options="shippingStatusList"
                            :info="verify"
                            @subQuick="getTableData"
                            url="order/order_pretreatment/quick"
                          >
                          </tableEditSelect>
                        </span>
                      </div>
                      <div v-if="order.creater">
                        录&nbsp;单&nbsp;人：{{ order.creater ? order.creater.adminer : '--' }}（{{
                          order.creater.created_at ? order.creater.created_at : '--'
                        }}）
                      </div>
                      <div>
                        发&nbsp;货&nbsp;人：{{ order.kd_adminer ? order.kd_adminer : '--' }}（{{ order.kd_adminer_time }}）
                      </div>
                      <div v-if="orderItem.is_self == 1 && verify.reports && verify.reports.length > 0">
                        上&nbsp;传&nbsp;人：{{
                          verify.reports && verify.reports.length > 0 ? verify.reports[0].report_adminer : '--'
                        }}（{{ verify.reports[0].updated_at }}）
                      </div>
                      <div class="star" v-if="order.status != 4 && order.status != 5 && order.status != 6 && order.status != 7">
                        处理星级：
                        <el-rate :value="verify.dispose_star" @change="value => star(value, verify.id, verify)"></el-rate>
                      </div>
                      <div class="flex" v-if="order.status != 4 && order.status != 5 && order.status != 6 && order.status != 7">
                        预处理时间：<tableEditDate
                          propsName="pretreatment_time"
                          :info="verify"
                          url="merchant/order/appoint/quick"
                        >
                        </tableEditDate>
                      </div>
                      <div class="order-money">
                        <div @click="showRemarkspretreatment(verify.id, verify.remark_logs)">
                          <div v-if="verify.remark_logs.length > 0">
                            备注：
                            <el-link type="danger" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 4"> </el-link>
                            <el-link type="primary" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 3"> </el-link>
                            <el-link type="warning" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 2"> </el-link>
                            <el-link type="info" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 1"> </el-link>
                          </div>
                          <div v-else>备注：<el-link type="info" icon="el-icon-s-flag"></el-link></div>
                        </div>
                      </div>
                      <div class="btngroup" v-if="order.status != 6 && order.status != 7">
                        <el-button size="mini" type="warning" @click="save">保存</el-button>
                        <el-button size="mini" type="success" @click="onSMS(order, ind, index)">短信 </el-button>
                        <div
                          style="margin-left: 10px;"
                          v-if="order.store.id == 17 || order.store.id == 18 || order.store.id == 4 || order.status != 0"
                        >
                          <el-button v-if="verify.audit_status == 0" size="mini" type="primary" @click="onExamine(verify.id)">
                            审核
                          </el-button>
                          <div v-else>已审核</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="orderItem.good && orderItem.more_codes && orderItem.more_codes == 1"
                    style=" color: #999da0; text-align: center; padding: 5px; text-decoration: underline; cursor: pointer;"
                    @click="getMoreCode(order.id, orderItem.id)"
                  >
                    查看更多
                  </div>
                </div>
                <div class="good-verifies" v-else>
                  <div class="verify" v-for="(verify, index) in orderItem.order_pretreatments" :key="index">
                    <div class="verify-body wrap1" v-if="verify.verify_codes && verify.verify_codes.appointments">
                      <div class="flex">
                        <i class="el-icon-connection" style="color: #007CFF; margin-right: 4px;"></i>
                        &nbsp;核销码：
                        <tableEditInput propsName="code" :info="verify.verify_codes" url="order/verify_codes/quick">
                        </tableEditInput>
                        <orderBind :info="verify.verify_codes" @subQuick="getTableData" style="margin-left: 10px;"> </orderBind>
                      </div>
                      <el-link
                        v-if="verify.verify_codes.appointments.length == 0"
                        type="primary"
                        icon="el-icon-date"
                        @click="setAppointment(verify.verify_codes, 0)"
                        >预约
                      </el-link>
                      <div v-else>
                        <div>
                          <i class="el-icon-user" style="color: #007CFF;"></i>
                          &nbsp;{{ verify.verify_codes.appointments[0].realname }}
                          <el-tag type="danger" size="mini" effect="dark" v-if="verify.verify_codes.appointments[0].sex == 2">
                            <i class="el-icon-female"></i> 女
                          </el-tag>
                          <el-tag type="success" size="mini" effect="dark" v-else> <i class="el-icon-male"></i> 男 </el-tag>
                          <el-tag color="#DAD787" size="mini" effect="dark" v-if="verify.verify_codes.appointments[0].merry == 2">
                            <i class="el-icon-user"></i> 未婚
                          </el-tag>
                          <el-tag color="#E59191" size="mini" effect="dark" v-else> <i class="el-icon-user"></i> 已婚 </el-tag>
                        </div>
                        <div>
                          <i class="el-icon-postcard" style="color: #007CFF"></i>
                          &nbsp;身份证：{{ verify.verify_codes.appointments[0].id_no }}
                        </div>
                        <div>
                          <i class="el-icon-mobile-phone" style="color: #007CFF"></i>
                          &nbsp;手机：{{ verify.verify_codes.appointments[0].mobile }}
                        </div>
                        <div v-if="verify.verify_codes.appointments[0].shop && verify.verify_codes.appointments[0].shop.area">
                          <i class="el-icon-location-outline" style="color: #007CFF"></i>
                          &nbsp;城市：{{ verify.verify_codes.appointments[0].shop.area.name }}
                        </div>
                        <div>
                          <i class="el-icon-school" style="color: #007CFF"></i>
                          &nbsp;预约分院：
                          <span v-if="verify.verify_codes.appointments[0].shop"
                            >[{{ verify.verify_codes.appointments[0].shop.title }}]</span
                          >
                          <span v-else> -- </span>
                        </div>
                        <div>
                          <i class="el-icon-date" style="color: #007CFF"></i>
                          &nbsp;预约日期：
                          <tableEditDate
                            style="display: inline-block"
                            propsName="visit_time"
                            @subQuick="getTableData"
                            :info="verify.verify_codes.appointments[0]"
                            url="order/appointment/quick"
                          ></tableEditDate>
                        </div>
                        <div class="editbtn">
                          <el-button
                            v-if="verify.verify_codes.appointments != '' && verify.verify_codes.appointments[0].audit_status != 1"
                            size="mini"
                            type="primary"
                            @click="onEditItem(verify.verify_codes.appointments[0])"
                          >
                            编辑
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <div class="verify-body wrap2">
                      <div v-if="verify.verify_codes && verify.verify_codes.appointments">
                        <div>业务/运营经理：{{ order.store.shopowner ? order.store.shopowner : '--' }}</div>
                        <div v-if="order.creater">
                          录&nbsp;单&nbsp;人：{{ order.creater ? order.creater.adminer : '--' }}（{{
                            order.creater.created_at ? order.creater.created_at : '--'
                          }}）
                        </div>
                        <div>
                          核&nbsp;销&nbsp;人：
                          {{
                            verify.verify_codes.modifications && verify.verify_codes.modifications.length > 0
                              ? verify.verify_codes.modifications[0].adminer
                              : '--'
                          }}（{{
                            verify.verify_codes.modifications && verify.verify_codes.modifications.length > 0
                              ? verify.verify_codes.modifications[0].created_at
                              : '--'
                          }}）
                        </div>
                        <div>
                          推&nbsp;荐&nbsp;人：/
                        </div>
                        <div>
                          <el-tag
                            size="mini"
                            v-if="
                              verify.verify_codes.appointments.length > 0 &&
                                (verify.verify_codes.appointments[0].status == 3 ||
                                  verify.verify_codes.appointments[0].status == 4)
                            "
                          >
                            已体检</el-tag
                          >
                        </div>
                      </div>
                      <div class="star" v-if="order.status != 4 && order.status != 5 && order.status != 6 && order.status != 7">
                        处理星级：
                        <el-rate :value="verify.dispose_star" @change="value => star(value, verify.id, verify)"></el-rate>
                      </div>
                      <div class="flex" v-if="order.status != 4 && order.status != 5 && order.status != 6 && order.status != 7">
                        预处理时间：<tableEditDate
                          propsName="pretreatment_time"
                          :info="verify"
                          url="merchant/order/appoint/quick"
                        >
                        </tableEditDate>
                      </div>
                      <div class="order-money">
                        <div @click="showRemarkspretreatment(verify.id, verify.remark_logs)">
                          <div v-if="verify.remark_logs.length > 0">
                            备注：
                            <el-link type="danger" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 4"> </el-link>
                            <el-link type="primary" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 3"> </el-link>
                            <el-link type="warning" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 2"> </el-link>
                            <el-link type="info" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 1"> </el-link>
                          </div>
                          <div v-else>备注：<el-link type="info" icon="el-icon-s-flag"></el-link></div>
                        </div>
                      </div>
                      <div class="btngroup" v-if="order.status != 6 && order.status != 7">
                        <el-button size="mini" type="warning" @click="save">保存</el-button>
                        <el-button size="mini" type="success" @click="onSMS(order, ind, index)">短信 </el-button>
                        <div
                          style="margin-left: 10px;"
                          v-if="order.store.id == 17 || order.store.id == 18 || order.store.id == 4 || order.status != 0"
                        >
                          <el-button v-if="verify.audit_status == 0" size="mini" type="primary" @click="onExamine(verify.id)">
                            审核
                          </el-button>
                          <div v-else>已审核</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="orderItem.good && orderItem.more_codes && orderItem.more_codes == 1"
                    style=" color: #999da0; text-align: center; padding: 5px; text-decoration: underline; cursor: pointer;"
                    @click="getMoreCode(order.id, orderItem.id)"
                  >
                    查看更多
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="order-operation">
            <div class="btns" style="text-align: center;">
              <div style="margin-bottom: 10px;">当前进度：</div>
              <div :key="key" v-for="(item, key) in order.statusLists">
                <div class="speeds">
                  {{ item }}
                </div>
                <i
                  style="margin-top: 5px; margin-bottom: 5px; color: #007CFF"
                  v-if="key < order.statusLists.length - 1"
                  class="el-icon-bottom"
                ></i>
              </div>
            </div>
            <div class="ispay">
              是否付款：<span style="color: #00AB22;" v-if="order.status != 0">是</span
              ><span style="color: #F10019;" v-else>否</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="color: #333; font-size: 12px; margin-bottom: 20px; float: right">
      订单实付总额：￥ {{ totalData.total_payment }}
    </div>

    <el-dialog title="短信发送" :visible.sync="smsShow" :close-on-click-modal="false" @close="cancelSMS">
      <el-form :model="smsForm" label-width="160px" :inline="false" size="small" style="height: 100%; overflow-y: auto">
        <el-form-item label="短信类型">
          <el-radio-group v-model="radioValue">
            <el-radio :label="1">订单短信</el-radio>
            <el-radio :label="2" v-if="smsForm.type == 1">预约短信 </el-radio>
            <el-radio :label="2" v-else disabled>预约短信</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="短信模板">
          <el-select v-model="smsForm.id" placeholder="选择短信模板" @change="choosedSMS">
            <el-option v-for="option in smsTemplates" :key="option.id" :label="option.message" :value="option.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="短信内容" prop="comment">
          <el-input
            type="textarea"
            v-model="smsForm.comment"
            :autosize="{ minRows: 8, maxRows: 20 }"
            placeholder="请填写短信内容"
            size="mini"
            style="width: 80%"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-table :data="smsHistories" border style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column label="短信内容" prop="msg"></el-table-column>
        <el-table-column label="发送人" width="100" prop="adminer"></el-table-column>
        <el-table-column label="发送时间" width="200" prop="created_at"></el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="cancelSMS">取消</el-button>
        <el-button type="primary" @click="subSMS">提交</el-button>
      </span>
    </el-dialog>

    <div class="flex">
      <el-pagination
        background
        layout="prev, pager, next, total,jumper"
        :page-count="maxpage"
        :total="total"
        @current-change="pageChange"
      >
      </el-pagination>
      <el-button size="mini" @click="pageChange" class="btn">确定</el-button>
    </div>

    <el-dialog title="编辑信息" :visible.sync="infoShow" width="60%" @close="resetInfo" :close-on-click-modal="false">
      <el-form :model="info" ref="info" :rules="rules" label-width="120px" :inline="false" size="small">
        <el-form-item label="平台" prop="platform_id">
          <el-radio-group v-model="info.platform_id" @change="getInfoStores">
            <el-radio v-for="platform in platforms" :key="platform.id" :label="platform.id">
              {{ platform.title }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="店铺" prop="store_id">
          <el-radio-group v-model="info.store_id">
            <el-radio v-for="store in infoStores" :key="store.id" :label="store.id">
              {{ store.title }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="订单号" prop="order_no">
          <el-input v-model="info.order_no"></el-input>
        </el-form-item>
        <el-form-item label="下单时间" prop="created_at">
          <el-input v-model="info.created_at"></el-input>
        </el-form-item>

        <el-form-item label="定金金额" prop="front_payment">
          <el-input v-model="info.front_payment"></el-input>
        </el-form-item>
        <el-form-item label="定金支付时间" prop="front_payment_time">
          <el-input v-model="info.front_payment_time"></el-input>
        </el-form-item>

        <el-form-item label="尾款金额" prop="final_payment">
          <el-input v-model="info.final_payment"></el-input>
        </el-form-item>
        <el-form-item label="支付时间(尾款)" prop="payed_at">
          <el-input v-model="info.payed_at"></el-input>
        </el-form-item>
        <el-form-item label="总实付金额" prop="payment">
          <el-input v-model="info.payment" placeholder="总实付金额 = 定金金额+尾款金额"></el-input>
        </el-form-item>

        <el-form-item label="属性" prop="pay_type">
          <el-radio-group v-model="info.status">
            <el-radio :label="0">待付款</el-radio>
            <el-radio :label="11">付定金</el-radio>
            <el-radio :label="1">已付款</el-radio>
            <el-radio :label="2">已发卡</el-radio>
            <el-radio :label="3">已发货</el-radio>
            <el-radio :label="4">交易完成</el-radio>
            <el-radio :label="5">退款中</el-radio>
            <el-radio :label="6">已退款</el-radio>
            <el-radio :label="7">已取消</el-radio>
            <el-radio :label="9">团单</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="结算方式" prop="settlement_type">
          <el-radio-group v-model="info.settlement_type">
            <el-radio :label="0">现结</el-radio>
            <el-radio :label="1">月结</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="是否售卡" prop="is_sell_card">
          <el-radio-group v-model="info.is_sell_card">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="归属项目" prop="item_type">
          <el-select v-model="info.item_type" filterable size="mini" clearable placeholder="选择归属项目" style="width: 100%">
            <el-option value="" label="选择归属项目">选择归属项目</el-option>
            <el-option :value="0" label="无">无</el-option>

            <el-option v-for="itemtype in orderItemType" :key="itemtype.id" :value="itemtype.id" :label="itemtype.title">
              {{ itemtype.title }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择产品" prop="goods" v-if="saveType == 1">
          <el-select
            v-model="orderGoodIds"
            ref="orderGoodIds"
            placeholder="请选择套餐"
            clearable
            filterable
            multiple
            @change="setOrderGoods"
            :filter-method="filterGoods"
            style="width: 100%"
          >
            <el-option v-for="good in curGoods" :key="good.id" :label="good.title" :value="good.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择客户" prop="channel_client_id">
          <el-select
            v-model="channel_client_id"
            ref="channel_client"
            placeholder="请输入客户名称"
            clearable
            filterable
            @change="setClient"
            :filter-method="filterClient"
            style="width: 100%"
          >
            <el-option v-for="client in channelClient" :key="client.id" :label="client.title" :value="client.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-divider comment-position="center">订单明细</el-divider>
        <el-table :data="orderGoods" border stripe>
          <el-table-column prop="thumb" label="缩略图" width="100">
            <template slot-scope="scope">
              <el-image :src="scope.row.thumb" fit="fill"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="套餐名"></el-table-column>
          <el-table-column prop="payment" label="实付单价" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.payment" size="mini" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="数量" size="mini" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.num" size="mini"></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="is_gift" label="是否赠品" size="mini" width="150">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.is_gift">
                <el-radio :label="0">非赠送</el-radio>
                <el-radio :label="1">赠送</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
        </el-table>

        <el-divider comment-position="center">支付信息</el-divider>
        <el-form-item label="支付方式" prop="pay_type">
          <el-radio-group v-model="info.pay_type">
            <el-radio v-for="item in payTypes" :key="item.name" :label="item.name">
              {{ item.title }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="团单核销码" prop="verify_code" v-if="info.status == 9">
          <el-input v-model="info.verify_code"></el-input>
        </el-form-item>
        <el-form-item label="会员ID" prop="nickname">
          <el-input v-model="info.nickname"></el-input>
        </el-form-item>
        <el-form-item label="所在城市" prop="area">
          <el-cascader v-if="infoShow" v-model="info.area" :props="props" placeholder="" style="width:100%;"></el-cascader>
        </el-form-item>
        <el-form-item label="联系手机" prop="mobile">
          <el-input v-model="info.mobile"></el-input>
        </el-form-item>
        <el-form-item label="收件人" prop="consignee">
          <el-input v-model="info.consignee"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="info.address"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="info.remark"></el-input>
        </el-form-item>
        <el-form-item label="结算周期">
          <el-date-picker
            v-model="periodDate"
            type="daterange"
            range-separator="——"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="mini"
            style="width: 260px;"
            @change="dateChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="预测应付" prop="forecast_receivable">
          <el-input
            v-model="info.forecast_receivable"
            placeholder="预测应收
                    "
            size="mini"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="orderhandleClose">取消</el-button>
        <el-button type="primary" @click="subInfo">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="预约信息"
      :visible.sync="showAppointment"
      width="40%"
      @close="resetAppointment"
      :close-on-click-modal="false"
    >
      <el-form
        :model="infoAppointment"
        ref="infoAppointment"
        :rules="appointRules"
        label-width="120px"
        :inline="false"
        size="small"
      >
        <el-form-item label="体检人姓名" prop="realname">
          <el-input v-model="infoAppointment.realname"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="infoAppointment.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="婚否" prop="merry">
          <el-radio-group v-model="infoAppointment.merry">
            <el-radio :label="1">已婚</el-radio>
            <el-radio :label="2">未婚</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="证件号" prop="id_no">
          <el-input v-model="infoAppointment.id_no"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mobile">
          <el-input v-model="infoAppointment.mobile"></el-input>
        </el-form-item>
        <el-form-item label="预约门店" prop="org_id">
          <el-select v-model="infoAppointment.org_id" filterable>
            <el-option v-for="shop in shops" :key="shop.id" :label="shop.title" :value="shop.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接种机构" prop="inoculate_org_id">
          <el-select v-model="infoAppointment.inoculate_org_id" placeholder="无选择" filterable>
            <el-option v-for="shop in shops2" :key="shop.id" :label="shop.title" :value="shop.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预约日期" prop="visit_time">
          <el-date-picker
            v-model="infoAppointment.visit_time"
            value-format="yyyy-MM-dd"
            type="date"
            size="mini"
            placeholder="选择体检日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showAppointment = false">取消</el-button>
        <el-button type="primary" :loading="saveLoading" @click="subAppointment">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="开卡" :visible.sync="showOpenCard" width="30%" @close="resetCard" :close-on-click-modal="false">
      <el-form :model="cardForm" ref="cardForm" :rules="cardRules" label-width="80px" :inline="false" size="mini">
        <el-form-item label="结算方式">
          <el-radio-group v-model="cardForm.type" @change="change">
            <el-radio :label="1">采购卡</el-radio>
            <el-radio :label="2">月结卡</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="结算渠道">
          <el-select v-model="cardForm.channel_id" filterable @change="getCards" style="width: 100%">
            <el-option v-for="channel in channels" :key="channel.id" :label="channel.title" :value="channel.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡号">
          <el-select v-model="cardForm.card_id" filterable style="width: 100%">
            <el-option
              v-for="card in cards"
              :key="card.id"
              :label="card.code + '[' + card.sex_text + (card.city ? card.city : '') + ']'"
              :value="card.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="showOpenCard = false">取消</el-button>
        <el-button type="primary" @click="openCard">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="退款" :visible.sync="showRefundStatus" width="50%" @close="resetRefund" :close-on-click-modal="false">
      <el-form :model="refundForm" ref="refundForm" :rules="refundRules" label-width="120px" :inline="false" size="mini">
        <el-form-item label="退款金额">
          <el-radio-group v-model="refundForm.refund_type">
            <el-radio :label="0">全额退款</el-radio>
            <el-radio :label="1">部分退款</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="退款方式">
          <el-radio-group v-model="refundForm.online_type">
            <el-radio :label="1">线上退款</el-radio>
            <el-radio :label="2">线下退款</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="退款金额">
          <el-input v-model="refundForm.diff_price" clearable></el-input>
        </el-form-item>
        <el-form-item label="退款账号类型">
          <el-radio-group v-model="refundForm.refund_account_type">
            <el-radio label="wxpay" v-if="refundForm.refund_account_type == 'wxpay'">微信</el-radio>
            <el-radio label="alipay" v-if="refundForm.refund_account_type != 'wxpay'">支付宝</el-radio>
            <el-radio label="credit" v-if="refundForm.refund_account_type != 'wxpay'">信用卡</el-radio>
            <el-radio label="bei" v-if="refundForm.refund_account_type != 'wxpay'">花呗</el-radio>
            <el-radio label="goback">原路返回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="退款账号">
          <el-input v-model="refundForm.refund_account"></el-input>
        </el-form-item>
        <el-form-item label="退款实名认证">
          <el-input v-model="refundForm.real_name"></el-input>
        </el-form-item>
        <el-form-item label="退款原因">
          <el-input v-model="refundForm.reason"></el-input>
        </el-form-item>
      </el-form>
      <el-divider comment-position="left">退款记录</el-divider>
      <el-table :data="refundLogs" border stripe>
        <el-table-column label="退款账号类型" prop="refund_account_type"></el-table-column>
        <el-table-column label="金额" prop="diff_price"></el-table-column>
        <el-table-column label="退款原因" prop="remark"></el-table-column>
        <el-table-column label="申请时间" prop="created_at"></el-table-column>
        <el-table-column label="退款状态" prop="status_text"></el-table-column>
        <el-table-column label="登记人" prop="adminer"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="photo1">
              <el-link
                :src="photo"
                fit="fill"
                :lazy="true"
                v-for="(photo, i) in scope.row.voucher_img"
                :key="i"
                @click="showPreview(photo)"
              >
                查看退款凭证{{ i + 1 }}</el-link
              >
            </div>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer">
        <el-button @click="showRefundStatus = false">取消</el-button>
        <el-button type="primary" :loading="saveLoading" @click="subRefund">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="备注记录" :visible.sync="showRemarksStatus" width="40%" @close="resetRemark" :close-on-click-modal="false">
      <el-form :model="remarkForm" ref="remarkForm" :rules="remarkRules" label-width="80px" :inline="false" size="normal">
        <el-form-item label="标记">
          <el-radio-group v-model="remarkForm.type">
            <el-radio :label="1">
              <el-link type="info" icon="el-icon-s-flag"></el-link>
            </el-radio>
            <el-radio :label="2">
              <el-link type="warning" icon="el-icon-s-flag"></el-link>
            </el-radio>
            <el-radio :label="3">
              <el-link type="primary" icon="el-icon-s-flag"></el-link>
            </el-radio>
            <el-radio :label="4">
              <el-link type="danger" icon="el-icon-s-flag"></el-link>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="remarkForm.remark" placeholder="请填写备注" size="mini"></el-input>
        </el-form-item>
      </el-form>
      <el-table :data="remarks" border stripe>
        <el-table-column type="index" label="序号" width="70px"></el-table-column>
        <el-table-column label="备注内容" prop="remark">
          <template slot-scope="scope">
            <el-link type="danger" icon="el-icon-s-flag" v-if="scope.row.type == 4"></el-link>
            <el-link type="primary" icon="el-icon-s-flag" v-if="scope.row.type == 3"></el-link>
            <el-link type="warning" icon="el-icon-s-flag" v-if="scope.row.type == 2"></el-link>
            <el-link type="info" icon="el-icon-s-flag" v-if="scope.row.type == 1"></el-link>
            {{ scope.row.remark }}
          </template>
        </el-table-column>
        <el-table-column label="备注人" prop="adminer"></el-table-column>
        <el-table-column label="备注人岗位" prop="position">
          <template slot-scope="scope">
            {{ scope.row.position == 1 ? '售中' : scope.row.position == 2 ? '售后' : scope.row.position == 3 ? '售前' : '' }}
          </template>
        </el-table-column>
        <el-table-column label="备注时间" prop="created_at"></el-table-column>
      </el-table>

      <span slot="footer">
        <el-button @click="showRemarksStatus = false">关闭</el-button>
        <el-button type="primary" @click="saveRemark">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="备注记录"
      :visible.sync="showRemarkspretreatmentStatus"
      width="40%"
      @close="pretreatmentresetRemark"
      :close-on-click-modal="false"
    >
      <el-form
        :model="pretreatmentremarkForm"
        ref="pretreatmentremarkForm"
        :rules="remarkRules"
        label-width="80px"
        :inline="false"
        size="normal"
      >
        <el-form-item label="标记">
          <el-radio-group v-model="pretreatmentremarkForm.type">
            <el-radio :label="1">
              <el-link type="info" icon="el-icon-s-flag"></el-link>
            </el-radio>
            <el-radio :label="2">
              <el-link type="warning" icon="el-icon-s-flag"></el-link>
            </el-radio>
            <el-radio :label="3">
              <el-link type="primary" icon="el-icon-s-flag"></el-link>
            </el-radio>
            <el-radio :label="4">
              <el-link type="danger" icon="el-icon-s-flag"></el-link>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="pretreatmentremarkForm.remark" placeholder="请填写备注" size="mini"> </el-input>
        </el-form-item>
      </el-form>
      <el-table :data="pretreatmentremarks" border stripe>
        <el-table-column type="index" label="序号" width="70px"></el-table-column>
        <el-table-column label="备注内容" prop="remark">
          <template slot-scope="scope">
            <el-link type="danger" icon="el-icon-s-flag" v-if="scope.row.type == 4"></el-link>
            <el-link type="primary" icon="el-icon-s-flag" v-if="scope.row.type == 3"></el-link>
            <el-link type="warning" icon="el-icon-s-flag" v-if="scope.row.type == 2"></el-link>
            <el-link type="info" icon="el-icon-s-flag" v-if="scope.row.type == 1"></el-link>
            {{ scope.row.remark }}
          </template>
        </el-table-column>
        <el-table-column label="备注人" prop="adminer"></el-table-column>
        <el-table-column label="备注人岗位" prop="position">
          <template slot-scope="scope">
            {{ scope.row.position == 1 ? '售中' : scope.row.position == 2 ? '售后' : scope.row.position == 3 ? '售前' : '' }}
          </template>
        </el-table-column>
        <el-table-column label="备注时间" prop="created_at"></el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="showRemarkspretreatmentStatus = false">关闭</el-button>
        <el-button type="primary" @click="saveRemarkpretreatment">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="订单发票" :visible.sync="showBillStatus" width="50%" @close="resetBillForm" :close-on-click-modal="false">
      <el-form
        :model="billForm"
        ref="billForm"
        :rules="billRule"
        label-width="120px"
        :inline="false"
        size="mini"
        style="height: 400px; overflow-y: scroll"
      >
        <el-form-item label="抬头类型">
          <el-radio-group v-model="billForm.company_type">
            <el-radio :label="1">企业</el-radio>
            <el-radio :label="2">个人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发票抬头">
          <el-input v-model="billForm.company_name" placeholder="发票抬头" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="公司地址" v-if="billForm.company_type == 1">
          <el-input v-model="billForm.company_addr" placeholder="公司地址" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="公司电话" v-if="billForm.company_type == 1">
          <el-input v-model="billForm.company_tel" placeholder="公司电话" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="公司开户行" v-if="billForm.company_type == 1">
          <el-input v-model="billForm.company_bank" placeholder="公司开户行" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="公司开户账号" v-if="billForm.company_type == 1">
          <el-input v-model="billForm.company_account" placeholder="公司开户账号" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="税号" v-if="billForm.company_type == 1">
          <el-input v-model="billForm.duty_no" placeholder="税号" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="申请人">
          <el-input v-model="billForm.realname" placeholder="申请人" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="发票内容">
          <el-input v-model="billForm.title" placeholder="发票内容" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="发票金额">
          <el-input v-model="billForm.amount" placeholder="发票金额" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="开票公司">
          <el-input v-model="billForm.company_billing" placeholder="开票公司" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="发票类型">
          <el-radio-group v-model="billForm.type">
            <el-radio :label="1">电子发票</el-radio>
            <el-radio :label="2">纸质发票</el-radio>
            <el-radio :label="3">专用电子发票</el-radio>
            <el-radio :label="4">专用纸质发票</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="billForm.remark" placeholder="备注" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="billForm.mobile" placeholder="联系电话" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱">
          <el-input v-model="billForm.email" placeholder="电子邮箱" size="mini"></el-input>
        </el-form-item>

        <el-form-item label="收件人" v-if="billForm.type == 2 || billForm.type == 4">
          <el-input v-model="billForm.consignee" placeholder="收件人" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="收件地址" v-if="billForm.type == 2 || billForm.type == 4">
          <el-input v-model="billForm.address" placeholder="收件地址" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="物流公司" v-if="billForm.type == 2 || billForm.type == 4">
          <el-input v-model="billForm.transport" placeholder="物流公司" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="快递单号" v-if="billForm.type == 2 || billForm.type == 4">
          <el-input v-model="billForm.transport_no" placeholder="快递单号" size="mini"></el-input>
        </el-form-item>

        <el-form-item label="开票凭证">
          <div class="photo">
            <el-image
              :src="photo"
              fit="fill"
              :lazy="true"
              v-for="(photo, i) in billForm.bill_photo"
              :key="i"
              @click="showPreview(photo)"
            ></el-image>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="showBillStatus = false">取消</el-button>
        <el-button type="primary" :loading="saveLoading" @click="onBill" v-if="!billForm.status || billForm.status == 0">
          提交</el-button
        >
      </span>
    </el-dialog>

    <el-dialog :visible.sync="photoShow">
      <img width="100%" :src="photoUrl" alt="" />
    </el-dialog>

    <el-dialog title="修改套餐" :visible.sync="showItemEdit" :before-close="handleClose" :close-on-click-modal="false">
      <el-form :model="itemEditform" :rules="itemEditRules">
        <el-form-item label="搜索更改套餐" label-width="120px">
          <el-input v-model="itemEditform.good_title" autocomplete="off" style="width: 300px"> </el-input>
          <el-button type="success" effect="dark" @click="itemEditSerchFunc" style="margin-left: 10px">搜索 </el-button>
        </el-form-item>
        <el-form-item label="选择套餐" label-width="120px" prop="good_id">
          <el-select v-model="itemEditform.good_id" value-key="" filterable placeholder="选择套餐" style="width: 300px">
            <el-option v-for="good in itemEditSearchGoods" :key="good.id" :label="good.title" :value="good.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="套餐是否赠送">
          <el-radio-group v-model="itemEditform.is_gift">
            <el-radio :label="0">非赠送</el-radio>
            <el-radio :label="1">赠送</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="itemEditform.verify_code_id <= 0" label="数量" label-width="120px" prop="num">
          <el-input v-model.number="itemEditform.num" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="单个套餐实付价" label-width="120px" prop="new_payment">
          <el-input v-model="itemEditform.new_payment" style="width: 300px"></el-input>
        </el-form-item>
        <span>（订单实付金额：￥{{ itemEditform.order_payment }}）</span>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="itemEditCancel()">取 消</el-button>
        <el-button type="primary" @click="itemEditSubmitFunc">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="增加套餐"
      :visible.sync="showAddItemGood"
      :before-close="closeAddItemGoodFunc"
      :close-on-click-modal="false"
    >
      <el-form :model="addItemGood" :rules="itemEditRules">
        <el-form-item label="搜索新加套餐" label-width="120px">
          <el-input v-model="addItemGood.good_title" autocomplete="off" style="width: 300px"> </el-input>
          <el-button type="success" effect="dark" @click="itemEditSerchFunc(1)" style="margin-left: 10px">
            搜索
          </el-button>
        </el-form-item>
        <el-form-item label="选择套餐" label-width="120px" prop="good_id">
          <el-select v-model="addItemGood.good_id" value-key="" filterable placeholder="选择套餐" style="width: 300px">
            <el-option v-for="good in itemEditSearchGoods" :key="good.id" :label="good.title" :value="good.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="套餐是否赠送">
          <el-radio-group v-model="addItemGood.is_gift">
            <el-radio :label="0">非赠送</el-radio>
            <el-radio :label="1">赠送</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="数量" label-width="120px" prop="num">
          <el-input v-model.number="addItemGood.num" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="单个套餐实付价" label-width="120px" prop="new_payment">
          <el-input v-model="addItemGood.new_payment" style="width: 300px"></el-input>
        </el-form-item>
        <span>（订单实付金额：￥{{ addItemGood.order_payment }}）</span>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeAddItemGoodFunc()">取 消</el-button>
        <el-button type="primary" :loading="saveLoading" @click="saveAddItemGood()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="修改订单总价"
      :visible.sync="showOrderPaymentEdit"
      :before-close="orderPaymentEditCancel"
      :close-on-click-modal="false"
    >
      <el-form :model="orderPaymentEditform">
        <el-form-item label="总实付价" label-width="200px" prop="order_payment">
          <el-input v-model="orderPaymentEditform.order_payment" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="是否平分更新到订单明细" label-width="200px">
          <el-radio-group v-model="orderPaymentEditform.update_item_payment">
            <el-radio :label="0">不更新</el-radio>
            <el-radio :label="1">更新</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="orderPaymentEditCancel()">取 消</el-button>
        <el-button type="primary" @click="orderPaymentEditSubmitFunc">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="查看更多"
      :visible.sync="showMoreCode"
      :before-close="showMoreCodeClose"
      :close-on-click-modal="false"
      width="50%"
    >
      <div v-loading="moreCodeLoad">
        <div class="batchs">
          <el-popconfirm
            placement="right"
            confirm-button-text="审核"
            cancel-button-text="取消"
            icon="el-icon-info"
            icon-color="red"
            title="确定要批量审核吗？"
            @confirm="orderPretreatment"
            style="margin-left: 10px;"
          >
            <el-button slot="reference" type="success" size="mini">批量审核</el-button>
          </el-popconfirm>
          <el-date-picker
            style="margin-left: 10px;"
            v-model="datevalue"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            size="mini"
          >
          </el-date-picker>
          <el-popconfirm
            placement="right"
            confirm-button-text="改预处理时间"
            cancel-button-text="取消"
            icon="el-icon-info"
            icon-color="red"
            title="确定要批量改时间吗？"
            @confirm="updateDate"
            style="margin: 0px 10px;"
          >
            <el-button slot="reference" type="primary" size="mini">批量改预处理时间</el-button>
          </el-popconfirm>
          <el-button slot="reference" type="warning" size="mini" @click="updateKd">批量修改快递单号</el-button>
        </div>
        <el-checkbox style="margin-top: 10px;" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div class="verify" v-for="verify in moreVerifyCodes.list" :key="verify.id">
          <div class="verify_child">
            <div>
              <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                <el-checkbox :label="verify.id">{{ verify.id }}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div>
              <div style="line-height: 25px;">
                <i class="el-icon-user" style="color: #007CFF;"></i>
                &nbsp;收件人：
                {{ moreVerifyCodes.order.consignee }}
              </div>
              <div style="line-height: 25px;">
                <i class="el-icon-mobile-phone" style="color: #007CFF"></i>
                &nbsp;手机号：
                {{ moreVerifyCodes.order.mobile }}
              </div>
              <div style="line-height: 25px;">
                <i class="el-icon-location-outline" style="color: #007CFF"></i>
                &nbsp;收件地址：
                {{ moreVerifyCodes.order.address }}
              </div>
              <div style="line-height: 25px;">
                <i class="el-icon-truck" style="color: #007CFF"></i>
                &nbsp;快递/物流：
                {{ moreVerifyCodes.order.kd_name }}
              </div>
              <div style="line-height: 25px;">
                <i class="el-icon-folder-checked" style="color: #007CFF"></i>
                &nbsp;快递单号：
                {{ verify.kd_no ? verify.kd_no : moreVerifyCodes.order.kd_no }}
              </div>
              <div style="line-height: 25px;">
                <i class="el-icon-time" style="color: #007CFF"></i>
                &nbsp;发货时间：
                {{ moreVerifyCodes.order.kd_adminer_time }}
              </div>
            </div>
            <div>
              <div style="line-height: 25px;">
                发货状态：<span style="color: #007CFF;">
                  <tableEditSelect
                    propsName="shipping_status"
                    :options="shippingStatusList"
                    :info="verify"
                    url="order/order_pretreatment/quick"
                  >
                  </tableEditSelect>
                </span>
              </div>
              <div class="flex" style="line-height: 25px;">
                处理星级：<el-rate :value="verify.dispose_star" @change="value => star(value, verify.id, verify)"> </el-rate>
              </div>
              <div class="flex" style="line-height: 25px;">
                预处理时间：<tableEditDate propsName="pretreatment_time" :info="verify" url="merchant/order/appoint/quick">
                </tableEditDate>
              </div>
              <div style="line-height: 25px; margin-top: 5px;" class="flex">
                <el-button v-if="verify.audit_status == 0" size="mini" type="primary" @click="onExamine(verify.id)"
                  >审核
                </el-button>
                <div v-else>已审核</div>
              </div>
              <div @click="showRemarkspretreatment(verify.id, verify.remark_logs)" style="cursor: pointer; margin-top: 10px;">
                <div v-if="verify.remark_logs.length > 0">
                  备注：
                  <el-link type="danger" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 4"> </el-link>
                  <el-link type="primary" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 3"> </el-link>
                  <el-link type="warning" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 2"> </el-link>
                  <el-link type="info" icon="el-icon-s-flag" v-if="verify.remark_logs[0].type == 1"> </el-link>
                </div>
                <div v-else>备注：<el-link type="info" icon="el-icon-s-flag"></el-link></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showMoreCodeClose">取 消</el-button>
        <el-button type="primary" @click="save">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="上传报告"
      :visible.sync="showImportReportDialog"
      width="40%"
      :before-close="importReportCancel"
      :close-on-click-modal="false"
    >
      <el-form
        :model="importReportData"
        ref="importReportData"
        :rules="rules"
        label-width="160px"
        :inline="false"
        size="small"
        style="height: 100%; overflow-y: auto"
      >
        <el-form-item label="检测人" prop="tester">
          <el-input v-model="importReportData.tester" style="width: 300px" placeholder="请输入检测人"> </el-input>
        </el-form-item>

        <el-form-item label="上传报告">
          <el-upload
            class="upload-demo"
            :action="uploadReportUrl"
            :headers="uploadHeaders"
            :file-list="file_list"
            :on-remove="handleRemove"
            :on-change="handleChange"
            :on-preview="handlePreview"
            :data="importReportData"
            accept=".pdf,.png,.jpg,.jpeg"
            :on-success="uploadSuccess"
            :on-progress="uploadProgress"
            :disabled="uploadReportLoading"
            name="report_file"
            :show-file-list="true"
            :auto-upload="false"
            :limit="1"
            ref="reportUpload"
          >
            <el-button slot="trigger" size="mini" type="primary">选择文件</el-button>

            <div slot="tip" class="el-upload__tip" style="color: red">
              （注：请上传.pdf,.png,.jpg,.jpeg文件<span v-if="importReportData.report_path"
                >，若要选择文件更换报告，请先删除下面报告文件</span
              >）
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="success" :loading="uploadReportLoading" @click="submitUpload">确定</el-button>
        <el-button @click="importReportCancel()">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="推荐人设置"
      :visible.sync="showSetReferrer"
      width="40%"
      :before-close="closeSetRefferrerFunc"
      :close-on-click-modal="false"
    >
      <el-form
        :model="setReferrerData"
        ref="setReferrerData"
        label-width="160px"
        :inline="false"
        size="small"
        style="height: 100%; overflow-y: auto"
      >
        <el-form-item label="选择推荐人" prop="staff_id">
          <el-select v-model="setReferrerData.recommend_staff_id" style="width: 80%" filterable clearable>
            <el-option v-for="staff in staffs" :key="staff.id" :label="staff.realname" :value="staff.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="推荐人提成百分比" prop="tester">
          <el-input v-model="setReferrerData.recommend_percent" style="width: 80%" placeholder="请输入推荐人提成百分比">
          </el-input>
          %
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="success" :loading="saveLoading" @click="doSetRefferrerFunc">确定</el-button>
        <el-button @click="closeSetRefferrerFunc()">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑信息" :visible.sync="showinfo" width="40%" @close="resetInfo" :close-on-click-modal="false">
      <el-form :model="info" ref="info" :rules="rules" label-width="120px" :inline="false" size="small">
        <el-form-item label="体检人姓名" prop="realname">
          <el-input v-model="info.realname"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="info.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="婚否" prop="merry">
          <el-radio-group v-model="info.merry">
            <el-radio :label="1">已婚</el-radio>
            <el-radio :label="2">未婚</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="证件号" prop="id_no">
          <el-input v-model="info.id_no"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mobile">
          <el-input v-model="info.mobile"></el-input>
        </el-form-item>
        <el-form-item label="体检机构" prop="org_id">
          <el-select v-model="info.org_id" placeholder="选择分院" clearable filterable>
            <el-option v-for="shop in shops" :key="shop.id" :label="shop.title" :value="shop.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接种机构" prop="inoculate_org_id">
          <el-select v-model="info.inoculate_org_id" placeholder="无选择" clearable filterable>
            <el-option v-for="shop in shops2" :key="shop.id" :label="shop.title" :value="shop.id"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="showinfo = false">取消</el-button>
        <el-button type="primary" @click="infosub">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量修改快递单号" :visible.sync="updateKdShow" width="20%" :close-on-click-modal="false">
      <el-form :model="updateKdInfo" ref="updateKdInfo" label-width="100px" :inline="false" size="small">
        <el-form-item label="快递单号" prop="kd_no">
          <el-input v-model="updateKdInfo.kd_no" style="width: 80%" placeholder="请输入快递单号" size="mini"> </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="closeUpdateKsInfo">取消</el-button>
        <el-button type="success" @click="subUpdateKsInfo">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableEditInput from '@/components/TableEditInput'
import tableEditSelect from '@/components/TableEditSelect'
import orderBind from '@/components/OrderBind'
import tableEditDate from '@/components/TableEditDate'

export default {
  name: 'appointmentsReal',
  components: {
    tableEditInput,
    orderBind,
    tableEditSelect,
    tableEditDate,
  },
  data() {
    var checkNum = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('数量不能为空'))
      } else if (value <= 0) {
        return callback(new Error('数量低于或等于0，将删除该套餐信息，请慎重操作'))
      }
    }
    var checkVerify = (rule, value, callback) => {
      if (value === '' && this.info.status == 9) {
        callback(new Error('请输入核销码'))
      } else {
        callback()
      }
    }
    return {
      props: {
        checkStrictly: true,
        lazy: true,
        value: 'code',
        label: 'name',
        lazyLoad: this.lazyLoadFn,
      },
      smsForm: {
        id: '',
        comment: '',
        type: 1,
      },
      smsShow: false,
      smsTemplates: [],
      smsHistories: [],
      smsTempForm: null,
      is_super: 0,
      power_change_goods: 0,
      roles: window.sessionStorage.getItem('roles'),
      referrer_set: 0,
      power_card_reback: 0,
      itemEditSearchGoods: [],
      itemEditform: {
        verify_code_id: 0,
        order_item_id: 0,
        order_id: 0,
        order_payment: 0,
        good_title: '',
        good_id: 0,
        num: 1,
        new_payment: 0,
        is_gift: 0,
      },
      orderPaymentEditform: {
        order_id: 0,
        order_payment: 0,
        update_item_payment: 0,
      },
      loading: false,
      actTableType: '9',
      actTableType2: '-1',
      provinces: [],
      cities: [],
      filter: {
        province: '',
        city_code: '',
        keyword: '',
        appo_status: '',
        status: [],
        time_type: 'created_at',
        price_type: '',
        appo_type: '',
        sort_type: '',
        sel_type: 4,
        is_pretreatment: 1,
        is_processed: '',
      },
      tableData: [],
      tableAll: [],
      page: 1,
      maxpage: 1,
      total: 0,
      showinfo: false,
      infoShow: false,
      saveType: 1, // 1新增 2编辑
      info: {
        platform_id: '',
        store_id: '',
        order_no: '',
        created_at: '',
        payed_at: '',
        pay_no: '',
        payment: '',
        status: 1,
        goods: [],
        pay_type: 'alipay',
        nickname: '',
        area: '',
        mobile: '',
        address: '',
        consignee: '',
        item_type: '',
        front_payment: 0,
        front_payment_time: '',
        final_payment: 0,
        settlement_type: 0,
        is_sell_card: 0,
        forecast_receivable: '',
        period_start: '',
        period_end: '',
      },
      rules: {
        platform_id: [
          {
            required: true,
            message: '请选择平台',
            trigger: 'change',
          },
        ],
        store_id: [
          {
            required: true,
            message: '请选择店铺',
            trigger: 'change',
          },
        ],
        order_no: [
          {
            required: true,
            message: '请填写订单号',
            trigger: 'blur',
          },
        ],
        payment: [
          {
            required: true,
            message: '请填写实付金额',
            trigger: 'blur',
          },
        ],
        created_at: [
          {
            required: true,
            message: '请填写下单时间',
            trigger: 'blur',
          },
        ],
        item_type: [
          {
            required: true,
            message: '请选择归属项目',
            trigger: 'blur',
          },
        ],
        nickname: [
          {
            required: true,
            message: '请填写下单人',
            trigger: 'blur',
          },
        ],
        area: [
          {
            required: true,
            message: '请选择下单人所在城市',
            trigger: 'change',
          },
        ],
        mobile: [
          {
            required: true,
            message: '请填写下单人手机',
            trigger: 'blur',
          },
        ],
        verify_code: [
          {
            validator: checkVerify,
            trigger: 'blur',
          },
        ],
      },
      itemEditRules: {
        num: [
          {
            validator: checkNum,
            trigger: 'blur',
          },
        ],
      },
      platforms: [],
      currentPlatformId: 0,
      stores: [],
      infoStores: [],
      payTypes: [],
      allGoods: [],
      curGoods: [],
      orderGoodIds: [],
      orderGoods: [],
      orderStatusList: [
        {
          id: 0,
          title: '待付款',
        },
        {
          id: 1,
          title: '已付款',
        },
        {
          id: 2,
          title: '已开卡',
        },
        {
          id: 3,
          title: '已发货',
        },
        {
          id: 4,
          title: '已完成',
        },
        {
          id: 5,
          title: '退款中',
        },
        {
          id: 6,
          title: '已退款',
        },
        {
          id: 7,
          title: '已取消',
        },
        {
          id: 9,
          title: '团单',
        },
        {
          id: 11,
          title: '付定金',
        },
      ],
      shippingStatusList: [
        {
          id: 0,
          title: '待发货',
        },
        {
          id: 1,
          title: '已发货',
        },
        {
          id: 3,
          title: '已取消',
        },
      ],
      kefus: [],
      showAppointment: false,
      currentVerify: null,
      infoAppointment: {
        org_id: '',
        sex: 1,
        merry: 1,
      },
      appointRules: {
        realname: [
          {
            required: true,
            message: '请填写体检人',
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            message: '请填写体检人联系电话',
            trigger: 'blur',
          },
        ],
        id_no: [
          {
            required: true,
            message: '请填写体检身份证',
            trigger: 'blur',
          },
        ],
        visit_time: [
          {
            required: true,
            message: '请选择体检日期',
            trigger: 'blur',
          },
        ],
        // org_id: [{
        // 	required: true,
        // 	message: "请选择体检分院",
        // 	trigger: "change",
        // }, ],
      },
      shops: [],
      shops2: [],
      cardForm: {
        type: 1,
        channel_id: '',
        card_id: '',
      },
      showOpenCard: false,
      channels: [],
      cards: [],
      cardRules: {
        card_id: [
          {
            required: true,
            message: '请选择体检卡',
            trigger: 'change',
          },
        ],
      },
      parentVerifyCodes: [],
      showRefundStatus: false,
      refundForm: {
        refund_account_type: 'alipay',
        refund_type: 0,
        online_type: 1,
        diff_price: '',
      },
      refundRules: {
        diff_price: [
          {
            required: true,
            message: '请填写退款金额',
            trigger: 'blur',
          },
        ],
        reason: [
          {
            required: true,
            message: '请填写退款原因',
            trigger: 'blur',
          },
        ],
      },
      refundLogs: [],
      totalData: {},
      showRemarksStatus: false,
      showRemarkspretreatmentStatus: false,
      remarks: [],
      pretreatmentremarks: [],
      remarkForm: {
        type: 1,
        remark: '',
        position: 1,
      },
      pretreatmentremarkForm: {
        type: 1,
        remark: '',
        position: 1,
      },
      remarkRules: {
        remark: [
          {
            required: true,
            message: '请填写备注内容',
            trigger: 'blur',
          },
        ],
      },
      billOrders: [],
      checkOrders: [],
      showBillStatus: false,
      billForm: {
        company_type: 1,
        type: 1,
        title: '体检费',
      },
      billRule: {},
      photoUrl: '',
      photoShow: false,
      showItemEdit: false,
      showOrderPaymentEdit: false,
      filterAllGoods: [],
      showMoreCode: false,
      moreVerifyCodes: [],
      moreCodeLoad: false,
      uploadHeaders: {
        Authorization: 'Bearer ' + sessionStorage.getItem('token'),
      },
      uploadUrl: this.$util.host + '/api/orders/uploadCustomersFile',
      uploadReportUrl: this.$util.host + '/api/order/order_items/upload_report',
      batchOpenCardOrderId: '',
      batchChannelId: '',
      batchPermission: false,
      uploadLoading: false,
      showImportReportDialog: false,
      importReportData: {
        item_id: 0,
        tester: '',
        report_path: '',
        the_num: 0,
      },
      uploadReportLoading: false,
      file_list: [],
      saveLoading: false,
      addItemGood: {
        good_title: '',
        order_id: 0,
        order_no: '',
        order_payment: 0,
        good_id: '',
        num: 1,
        new_payment: 0,
        is_gift: 0,
      },
      showAddItemGood: false,
      showSetReferrer: false,
      setReferrerData: {
        order_id: 0,
        recommend_staff_id: '',
        recommend_percent: 20,
      },
      staffs: [],
      areas: [],
      orderItemType: [],
      checkAll: false,
      isIndeterminate: false,
      checkList: [],
      datevalue: '',
      radioValue: 1,
      mobile1: '',
      mobile2: '',
      appointment_id: '',
      periodDate: [],
      channelClient: [],
      channel_client_id: '',
      updateKdInfo: {
        ids: [],
        kd_no: '',
      },
      updateKdShow: false,
      orderInfo: {
        order_id: '',
        order_item_id: '',
      },
    }
  },
  mounted() {
    let query = this.$route.query
    if (query.keyword) {
      this.filter.keyword = query.keyword
      if (query.member_id) {
        this.filter.member_id = query.member_id
      }
      this.page = 1
      this.filter.city_code = ''
    }
    this.getTableData()
    this.getPlatforms();
    this.getStores();
    this.getPayTypes();
    this.getGoods();
    // this.getKefus();
    this.getCascade();
    this.getProvinces();
  },
  methods: {
    lazyLoadFn(node, resolve) {
      let data = { model: 'Area', level: node.level + 1, parent_code: node.value ? node.value : '' }
      if (node.level < 5) {
        this.$util.get('slc', data).then(res => {
          resolve(res)
        })
      } else {
        data = { model: 'ServiceArea', community_code: node.value ? node.value : '' }
        this.$util.get('slc', data).then(res => {
          resolve(
            res.map(item => {
              return { ...item, name: item.title, code: item.id, leaf: true }
            })
          )
        })
      }
    },
    break() {
      let bool = true
      if (bool) return
    },
    star(value, id, row) {
      this.$confirm('是否确认修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$util.put('order/order_pretreatment/quick/' + id, {
            field: 'dispose_star',
            value: value,
          })
          this.$message({
            type: 'success',
            message: '修改成功!',
          })
          // this.getTableData();
          row.dispose_star = value
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消修改',
          })
        })
    },
    onSMS(row, ind, index) {
      if (row.order_items[ind].order_pretreatments[index].verify_codes) {
        if ((row.id, row.order_items[ind].order_pretreatments[index].verify_codes.appointments.length > 0)) {
          this.smsForm.type = 1
        } else {
          this.smsForm.type = 2
        }
      } else {
        this.smsForm.type = 2
      }
      this.smsShow = true
      if (row.order_items[ind].order_pretreatments[index].verify_codes) {
        if ((row.id, row.order_items[ind].order_pretreatments[index].verify_codes.appointments.length > 0)) {
          this.getSMS(row.id, row.order_items[ind].order_pretreatments[index].verify_codes.appointments[0].id)
          this.appointment_id = row.order_items[ind].order_pretreatments[index].verify_codes.appointments[0].id
        } else {
          this.getSMS(row.id, '')
          this.appointment_id = ''
        }
      } else {
        this.getSMS(row.id, '')
        this.appointment_id = ''
      }
      var name
      var city
      var shop
      var product
      if (row.order_items[ind].order_pretreatments[index].verify_codes) {
        if (row.order_items[ind].order_pretreatments[index].verify_codes.appointments.length > 0) {
          name = row.order_items[ind].order_pretreatments[index].verify_codes.appointments[0].realname
        } else {
          name = '{name}'
        }
      } else {
        name = '{name}'
      }
      if (row.order_items[ind].order_pretreatments[index].verify_codes) {
        if (row.order_items[ind].order_pretreatments[index].verify_codes.appointments.length > 0) {
          this.mobile1 = row.mobile
          this.mobile2 = row.order_items[ind].order_pretreatments[index].verify_codes.appointments[0].mobile
        } else {
          this.mobile1 = row.mobile
        }
      } else {
        this.mobile1 = row.mobile
      }
      if (row.order_items[ind].order_pretreatments[index].verify_codes) {
        if (row.order_items[ind].order_pretreatments[index].verify_codes.appointments.length > 0) {
          if (row.order_items[ind].order_pretreatments[index].verify_codes.appointments[0].shop) {
            if (row.order_items[ind].order_pretreatments[index].verify_codes.appointments[0].shop.area) {
              if (row.order_items[ind].order_pretreatments[index].verify_codes.appointments[0].shop.area.name) {
                city = row.order_items[ind].order_pretreatments[index].verify_codes.appointments[0].shop.area.name
              } else {
                city = '{city}'
              }
            } else {
              city = '{city}'
            }
          } else {
            city = '{city}'
          }
        } else {
          city = '{city}'
        }
      } else {
        city = '{city}'
      }
      if (row.store) {
        if (row.store.note_title) {
          shop = row.store.note_title
        } else {
          shop = '{shop}'
        }
      } else {
        shop = '{shop}'
      }
      if (row.order_items[ind]) {
        if (row.order_items[ind].title) {
          product = row.order_items[ind].title.replace('【', '')
          product = product.replace('】', '')
        }
      } else {
        product = '{product}'
      }

      this.smsTempForm = {
        id: row.id,
        name: name,
        city: city,
        shop: shop,
        product: product,
        store_id: row.store.id,
      }
    },
    getSMS(id, pid) {
      this.$util
        .get('phone/phone_message', {
          model: 'SmsTemplate',
        })
        .then(res => {
          this.smsTemplates = res.data
        })
      this.$util
        .get('orders/note_logs', {
          order_id: id,
          appointment_id: pid,
        })
        .then(res => {
          this.smsHistories = res
        })
    },
    choosedSMS(val) {
      let comment = ''
      this.smsTemplates.forEach(smsTemplate => {
        if (smsTemplate.id == val) {
          comment = smsTemplate.comment
        }
      })
      var name = new RegExp('{name}', 'g')
      var city = new RegExp('{city}', 'g')
      var product = new RegExp('{product}', 'g')
      if (comment.indexOf('{shop}') >= 0) {
        comment = comment.replace('{shop}', this.smsTempForm.shop)
      }
      if (comment.indexOf('{name}') >= 0) {
        comment = comment.replace(name, this.smsTempForm.name)
      }
      if (comment.indexOf('{product}') >= 0) {
        comment = comment.replace(product, this.smsTempForm.product)
      }
      if (comment.indexOf('{city}') >= 0) {
        comment = comment.replace(city, this.smsTempForm.city)
      }
      if (comment.indexOf('{mobile}') >= 0) {
        comment = comment.replace('{mobile}', this.smsTempForm.mobile)
      }
      this.smsForm.comment = '【' + this.smsTempForm.shop + '】' + comment
    },
    cancelSMS() {
      this.smsShow = false
      this.smsForm = {
        id: '',
        comment: '',
        type: 1,
      }
      this.smsTempForm = null
    },
    subSMS() {
      let phone
      if (this.radioValue == 1) {
        phone = this.mobile1
        this.appointment_id = ''
      } else {
        phone = this.mobile2
      }
      let data = {
        remark: '',
        msg: this.smsForm.comment,
        order_id: this.smsTempForm.id,
        phone: phone,
        appointment_id: this.appointment_id,
        store_id: this.smsTempForm.store_id,
      }
      this.$util.get('phone/sendMsg', data).then(() => {
        this.smsShow = false
        this.smsForm = {
          id: '',
          comment: '',
          type: 1,
        }
        this.smsTempForm = null
      })
    },
    getTableData() {
      this.tableData = []
      this.loading = true
      let data = this.filter
      data.page = this.page
      this.$util.get('/merchant/order/preorder/real', data).then(res => {
        this.tableData = res.data
        this.tableAll = res
        this.loading = false
        this.maxpage = res.last_page
        this.totalData = res.total_data
        this.total = res.total
        this.power_change_goods = res.power_change_goods
        this.referrer_set = res.referrer_set
        this.power_card_reback = res.power_card_reback
        this.is_super = res.is_super
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].shipping_status == 0) {
            this.tableData[i].statusLists = ['待发货']
          } else if (this.tableData[i].shipping_status == 1) {
            this.tableData[i].statusLists = ['待发货', '已发货']
          } else if (this.tableData[i].shipping_status == 2) {
            this.tableData[i].statusLists = ['待发货', '已发货', '已完成']
          } else {
            this.tableData[i].statusLists = ['已取消']
          }
        }
      })
      this.showMoreCodeClose()
    },
    changeTab(tab) {
      this.tableData = []
      this.page = 1
      this.maxpage = 1
      this.total = 0
      this.totalData = {}
      if (tab.name >= 0) {
        this.filter.status = [tab.name]
        this.filter.is_pretreatment = ''
        this.filter.is_processed = ''
      }
      if (tab.name < 0) {
        this.filter.is_pretreatment = ''
        this.filter.is_processed = ''
        this.filter.status = []
      }
      if (tab.name == 9) {
        this.filter.await_shiping = ''
        this.filter.is_pretreatment = 1
        this.filter.is_processed = ''
        this.filter.status = []
      }
      if (tab.name == 12) {
        this.filter.await_shiping = ''
        this.filter.is_pretreatment = ''
        this.filter.is_processed = 1
        this.filter.status = []
      }
      this.getTableData()
    },
    changeTab2(tab2) {
      this.tableData = []
      this.page = 1
      this.maxpage = 1
      this.total = 0
      this.totalData = {}
      if (tab2.name >= 0) {
        this.filter.appo_status = tab2.name
      }
      this.getTableData()
    },
    getPlatforms() {
      this.$util
        .get('slc', {
          model: 'Platform',
        })
        .then(res => {
          this.platforms = res
        })
    },
    getStores() {
      this.$util
        .get('slc', {
          model: 'Store',
        })
        .then(res => {
          this.stores = res
        })
    },
    getPayTypes() {
      this.$util
        .get('slc', {
          model: 'PayType',
        })
        .then(res => {
          this.payTypes = res
        })
    },
    getGoods() {
      this.$util
        .get('slc', {
          model: 'Good',
        })
        .then(res => {
          this.allGoods = res
        })
    },
    getKefus() {
      this.$util
        .get('slc', {
          model: 'User',
        })
        .then(res => {
          this.kefus = res
        })
    },
    onSearch() {
      this.tableData = []
      this.page = 1
      this.maxpage = 1
      this.total = 0
      this.filter.member_id = ''
      this.getTableData()
    },
    onRefresh() {
      this.actTableType = '9'
      this.actTableType2 = '-1'
      this.tableData = []
      this.page = 1
      this.maxpage = 1
      this.total = 0
      this.getTableData()
    },
    getInfoStores() {
      this.currentPlatformId = this.info.platform_id
      if (this.info.platform_id == 11 || this.info.platform_id == 16) {
        this.info.pay_type = 'alipay'
      } else {
        this.info.pay_type = 'wxpay'
      }
      if (this.info.platform_id == 15 || this.info.platform_id == 18) {
        //线下
        if (this.saveType == 1) {
          this.info.order_no = this.$moment(new Date()).format('YYYYMMDDHHmmss') + Math.ceil(Math.random() * 10000)
          this.info.created_at = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
          this.info.payed_at = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        }
      }
      this.getChildStores(this.info.platform_id)
    },
    getChildStores(platform_id) {
      this.$util
        .get('slc', {
          model: 'Store',
          pid: platform_id,
        })
        .then(res => {
          this.infoStores = res
        })
    },
    getFilterStores() {
      this.currentPlatformId = this.filter.platform_id
      this.getStores()
    },
    pageChange(page) {
      this.tableData = []
      this.page = page
      this.getTableData()
    },
    onCreate() {
      this.getOrderItemType()
      this.saveType = 1
      this.infoShow = true
      this.rules.goods = [
        {
          required: true,
          message: '请选择产品',
          trigger: 'blur',
        },
      ]
    },
    onEdit(row) {
      this.channel_client_id = ''
      this.getOrderItemType()
      this.periodDate = [row.period_start, row.period_end]
      this.saveType = 2
      this.info = {
        id: row.id,
        platform_id: row.platform_id,
        store_id: row.store_id,
        order_no: row.order_no,
        created_at: row.created_at,
        payed_at: row.payed_at,
        pay_no: row.pay_no,
        payment: row.payment,
        status: row.status,
        pay_type: row.pay_type,
        nickname: row.member ? row.member.nickname : '',
        city: row.city,
        mobile: row.mobile,
        address: row.address,
        consignee: row.consignee,
        item_type: row.item_type,
        is_sell_card: row.is_sell_card,
        front_payment: row.front_payment,
        front_payment_time: row.front_payment_time,
        final_payment: row.final_payment,
        settlement_type: row.settlement_type,
        channel_client_id: row.channel_client_id == 0 ? '' : row.channel_client_id,
      }
      this.channel_client_id = row.channel_client_id == 0 ? '' : row.channel_client_id
      row.area = []
      if (row.service_area_id > 0) {
        this.info.area = [
          row.province_code,
          row.city_code,
          row.district_code,
          row.street_code,
          row.community_code,
          row.service_area_id,
        ]
      } else if (row.community_code > 0) {
        this.info.area = [row.province_code, row.city_code, row.district_code, row.street_code, row.community_code]
      } else if (row.street_code > 0) {
        this.info.area = [row.province_code, row.city_code, row.district_code, row.street_code]
      } else if (row.district_code > 0) {
        this.info.area = [row.province_code, row.city_code, row.district_code]
      } else if (row.city_code > 0) {
        this.info.area = [row.province_code, row.city_code]
      } else if (row.province_code > 0) {
        this.info.area = [row.province_code]
      }
      delete this.rules.goods

      this.$util
        .get('slc', {
          model: 'Store',
          pid: row.platform_id,
        })
        .then(res => {
          this.infoStores = res
          this.info.store_id = row.store_id
        })

      row.order_items.forEach(item => {
        let orderGood = {}
        orderGood.good_id = item.good_id
        orderGood.title = item.title
        orderGood.thumb = item.thumb
        orderGood.num = item.num
        orderGood.sale_price = item.sale_price
        orderGood.payment = item.payment
        orderGood.is_gift = item.is_gift ? item.is_gift : 0
        this.orderGoods.push(orderGood)
      })
      this.infoShow = true
      this.$nextTick(() => {
        this.$refs.info.clearValidate()
      })
    },
    onDel(row) {
      this.$confirm('删除后相关数据也将会一起被删除，确定删除吗？')
        .then(() => {
          this.$util.del('orders/' + row.id).then(res => {
            if (res.code != 0) {
              this.$message(res.msg ? res.msg : '操作失败')
            } else {
              this.getTableData()
            }
          })
        })
        .catch(() => {})
    },
    onQuick(id, field, val) {
      this.$util
        .put('orders/quick/' + id, {
          field: field,
          value: val,
        })
        .then(() => {
          this.getTableData()
        })
    },
    subInfo() {
      this.$refs['info'].validate(valid => {
        if (valid) {
          this.$confirm('确定提交保存订单信息吗？')
            .then(() => {
              if (this.saveType == 1) {
                this.$util.post('orders', this.info).then(res => {
                  if (res.code != 0) {
                    this.$message(res.msg ? res.msg : '操作失败')
                  } else {
                    this.getTableData()
                    this.infoShow = false
                    this.periodDate = []
                    this.channel_client_id = ''
                  }
                })
              } else {
                this.$util.put('orders/' + this.info.id, this.info).then(res => {
                  if (res.code != 0) {
                    this.$message(res.msg ? res.msg : '操作失败')
                  } else {
                    this.getTableData()
                    this.infoShow = false
                    this.channel_client_id = ''
                  }
                })
              }
            })
            .catch(() => {})
        } else {
          return false
        }
      })
    },
    onBill() {
      this.saveLoading = true
      if (this.billForm.id) {
        this.$util.put('finances/order/bill/' + this.billForm.id, this.billForm).then(res => {
          this.saveLoading = false
          delete this.billForm.orderIds
          if (res.code > 0) {
            this.$message(res.msg)
          } else {
            this.billOrders = []
            this.$message('提交成功')
            this.getTableData()
          }
          this.billOrders = []
        })
      } else {
        this.$util.post('finances/order/bill', this.billForm).then(res => {
          this.saveLoading = false
          if (res.code > 0) {
            this.$message(res.msg)
          } else {
            this.billOrders = []
            this.$message('提交成功')
            this.getTableData()
            this.showBillStatus = false
          }
        })
      }
    },
    onExamine(id) {
      this.$confirm('审核订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$util
            .put('/merchant/order/appoint/quick/' + id, {
              field: 'audit_status',
              value: 1,
            })
            .then(res => {
              if (res.code != 0) {
                this.$message(res.msg)
              } else {
                if (this.showMoreCode) {
                  this.getGoodsByShippingStatus(this.orderInfo).then(res => {
                    this.moreVerifyCodes.list = res.list
                    this.updateKdShow = false
                  })
                } else {
                  this.getTableData()
                }
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消审核',
          })
        })
    },

    resetInfo() {
      this.periodDate = []
      this.info = {
        platform_id: '',
        store_id: '',
        order_no: '',
        created_at: '',
        payed_at: '',
        pay_no: '',
        payment: '',
        status: 1,
        goods: '',
        pay_type: 'alipay',
        nickname: '',
        city: '',
        mobile: '',
        address: '',
        consignee: '',
        item_type: '',
        front_payment: 0,
        front_payment_time: '',
        final_payment: 0,
        settlement_type: 0,
        is_sell_card: 0,
        forecast_receivable: '',
        period_start: '',
        period_end: '',
      }
      this.orderGoodIds = []
      this.orderGoods = []
      this.infoStores = []
      this.filterAllGoods = []
      this.curGoods = []
      this.rules = {
        platform_id: [
          {
            required: true,
            message: '请选择平台',
            trigger: 'change',
          },
        ],
        store_id: [
          {
            required: true,
            message: '请选择店铺',
            trigger: 'change',
          },
        ],
        order_no: [
          {
            required: true,
            message: '请填写订单号',
            trigger: 'blur',
          },
        ],
        payment: [
          {
            required: true,
            message: '请填写实付金额',
            trigger: 'blur',
          },
        ],
        created_at: [
          {
            required: true,
            message: '请填写下单时间',
            trigger: 'blur',
          },
        ],
        item_type: [
          {
            required: true,
            message: '请选择归属项目',
            trigger: 'blur',
          },
        ],
        nickname: [
          {
            required: true,
            message: '请填写下单人',
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            message: '请填写下单人手机',
            trigger: 'blur',
          },
        ],
        area: [
          {
            required: true,
            message: '请选择下单人所在城市',
            trigger: 'change',
          },
        ],
      }
    },
    onSend() {},
    onPrice(order) {
      this.orderPaymentEditform.order_id = order.id
      this.orderPaymentEditform.order_payment = order.payment
      this.orderPaymentEditform.update_item_payment = 0
      this.showOrderPaymentEdit = true
    },
    onRefund(row) {
      this.refundForm.order_id = row.id
      this.refundForm.diff_price = row.payment
      this.refundForm.platform = row.platform_id
      this.refundForm.store = row.store_id
      this.refundForm.order_no = row.order_no
      this.refundForm.refund_account_type = row.pay_type
      this.refundLogs = row.refund_difference_logs
      this.showRefundStatus = true
    },
    setOrderGoods() {
      this.orderGoods = []
      for (let i = 0; i < this.orderGoodIds.length; i++) {
        const id = this.orderGoodIds[i]
        for (var g = 0; g < this.filterAllGoods.length; g++) {
          let good = this.filterAllGoods[g]
          if (good.id == id) {
            let orderGood = {}
            orderGood.good_id = good.id
            orderGood.title = good.title
            orderGood.thumb = good.thumb
            orderGood.num = 1
            orderGood.sale_price = good.sale_price
            orderGood.is_gift = 0
            this.orderGoods.push(orderGood)
            break
          }
        }
      }
      this.info.goods = this.orderGoods
      this.$nextTick(() => {
        this.$refs.orderGoodIds.blur()
      })
    },
    setClient(value) {
      this.info.channel_client_id = value
    },
    filterGoods(query) {
      this.curGoods = []
      this.filterAllGoods = []
      if (query) {
        this.$util
          .get('slc', {
            model: 'Good',
            title: query,
          })
          .then(res => {
            res.forEach(good => {
              this.curGoods.push({
                id: good.id,
                title: good.title,
                thumb: good.thumb,
                sale_price: good.sale_price,
              })
              this.filterAllGoods.push({
                id: good.id,
                title: good.title,
                thumb: good.thumb,
                sale_price: good.sale_price,
              })
            })
          })
      }
    },
    filterClient(query) {
      this.channelClient = []
      if (query) {
        this.$util
          .get('slc', {
            model: 'ChannelClient',
            name: query,
          })
          .then(res => {
            this.channelClient = []
            res.forEach(client => {
              this.channelClient.push({
                id: client.id,
                title: client.code + ' / ' + client.name,
              })
            })
          })
      }
    },
    setVerifyCode(id, field, val) {
      this.$util
        .put('order/verify_codes/quick/' + id, {
          field: field,
          value: val,
        })
        .then(() => {
          this.getTableData()
        })
    },
    setOrderAdminer(id) {
      this.$util
        .put('orders/quick/' + id, {
          field: 'adminer',
          value: '',
        })
        .then(res => {
          if (res.code != 0) {
            this.$message(res.msg ? res.msg : '操作失败')
          } else {
            this.getTableData()
          }
        })
    },
    setOrderItemKd(row) {
      let data = {
        kd_name: row.kd_name,
        kd_no: row.kd_no,
        consignee: row.consignee,
        kd_fee: row.kd_fee,
      }
      row.kdShow = false
      this.$util.put('order/save_kd_info/' + row.id, data).then(res => {
        if (res.code != 0) {
          this.$message.error(res.msg ? res.msg : '操作失败')
        } else {
          this.$message.success('保存成功')
        }
      })
    },
    setOrderItemHj(row) {
      let data = {
        hj_name: row.hj_name,
        hj_no: row.hj_no,
      }
      row.hjShow = false
      this.$util.put('order/order_items/' + row.id, data).then(() => {
        this.getTableData()
      })
    },
    setAppointment(verify, appointment) {
      this.currentVerify = verify
      this.showAppointment = true
      if (appointment) {
        this.infoAppointment = appointment
      }
      let itemId = verify && verify.order_item_id ? verify.order_item_id : 0
      this.getShops(itemId)
      this.getShops2(itemId)
    },
    resetAppointment() {
      this.infoAppointment = {
        org_id: '',
        sex: 1,
        merry: 1,
      }
    },
    subAppointment() {
      this.$refs['infoAppointment'].validate(valid => {
        if (valid) {
          this.infoAppointment.verify_code_id = this.currentVerify.id
          this.saveLoading = true
          if (this.currentVerify.appointments.length > 0) {
            this.$util.put('order/appointment/' + this.currentVerify.appointments[0].id, this.infoAppointment).then(() => {
              this.getTableData()
              this.saveLoading = false
              this.showAppointment = false
            })
          } else {
            this.$util.post('order/appointment', this.infoAppointment).then(() => {
              this.getTableData()
              this.showAppointment = false
              this.saveLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    setOrderItemParent(row) {
      row.parentShow = false
      this.$util
        .put('order/order_items/quick/' + row.id, {
          field: 'parent_order_no',
          value: row.parent_order_no,
        })
        .then(() => {
          this.getTableData()
        })
    },
    getShops(itemId) {
      this.$util
        .get('slc', {
          model: 'Shop',
          item_id: itemId,
        })
        .then(res => {
          this.shops = res
        })
    },
    getShops2(itemId) {
      this.$util
        .get('slc', {
          model: 'Shop',
          item_id: itemId,
          is_internal: 1,
        })
        .then(res => {
          this.shops2 = res
        })
    },
    openCardShow(vid, gid) {
      this.showOpenCard = true
      this.cardForm.verify_id = vid
      this.cardForm.good_id = gid
      this.getChannels()
    },
    openCard() {
      this.$refs['cardForm'].validate(valid => {
        if (valid) {
          this.$util
            .put('order/verify_codes/quick/' + this.cardForm.verify_id, {
              field: 'card_id',
              value: this.cardForm.card_id,
            })
            .then(res => {
              if (res.code != 0) {
                this.$message(res.msg ? res.msg : '操作失败')
              } else {
                this.showOpenCard = false
                this.getTableData()
              }
            })
        } else {
          return false
        }
      })
    },
    getCards() {
      this.$util
        .get('slc', {
          model: 'Card',
          good_id: this.cardForm.good_id,
          channel_id: this.cardForm.channel_id,
          type: this.cardForm.type,
        })
        .then(res => {
          this.cards = res
        })
    },
    getChannels() {
      this.$util
        .get('slc', {
          model: 'Channel',
        })
        .then(res => {
          this.channels = res
        })
    },
    resetCard() {
      this.cardForm = {
        type: 1,
        channel_id: '',
        card_id: '',
      }
      this.cards = ''
    },
    resetRefund() {
      this.refundForm = {
        refund_account_type: 'alipay',
        refund_type: 0,
        online_type: 1,
        diff_price: '',
      }
    },
    subRefund() {
      this.saveLoading = true
      this.$util.post('finances/order/refund_difference', this.refundForm).then(res => {
        this.saveLoading = false
        if (res.code != 0) {
          this.$message(res.msg ? res.msg : '操作失败')
        } else {
          this.getTableData()
          this.showRefundStatus = false
        }
      })
    },
    showRemarks(id, remarks) {
      this.showRemarksStatus = true
      this.remarks = remarks
      this.remarkForm.order_id = id
    },
    showRemarkspretreatment(id, remarks) {
      this.showRemarkspretreatmentStatus = true
      this.pretreatmentremarks = remarks
      this.pretreatmentremarkForm.order_pretreatment_id = id
    },
    resetRemark() {
      this.remarkForm = {
        type: 1,
        remark: '',
        position: 1,
      }
    },
    pretreatmentresetRemark() {
      this.pretreatmentremarkForm = {
        type: 1,
        remark: '',
        position: 1,
      }
    },
    saveRemark() {
      this.$refs['remarkForm'].validate(valid => {
        if (valid) {
          this.$util.post('order/orderRemarkLogs', this.remarkForm).then(() => {
            this.getTableData()
            this.showRemarksStatus = false
          })
        } else {
          return false
        }
      })
    },
    saveRemarkpretreatment() {
      this.$refs['pretreatmentremarkForm'].validate(valid => {
        if (valid) {
          this.$util.post('order/orderPretreatmentRemarkLogs', this.pretreatmentremarkForm).then(() => {
            this.getTableData()
            this.showRemarkspretreatmentStatus = false
          })
        } else {
          return false
        }
      })
    },
    showBill() {
      if (this.billOrders.length > 0) {
        let amount = 0
        let ids = []
        this.billOrders.forEach(order => {
          amount = amount + parseFloat(order.payment)
          ids.push(order.id)
        })
        this.billForm.amount = amount
        this.billForm.orderIds = ids
        this.showBillStatus = true
      } else {
        this.$message({
          showClose: true,
          message: '请选择开票订单',
          type: 'danger',
        })
      }
    },
    showOrderBill(bill) {
      this.billForm = bill
      this.showBillStatus = true
    },
    resetBillForm() {
      this.billForm = {
        company_type: 1,
        type: 1,
        title: '体检费',
      }
    },
    showPreview(url) {
      var arr = url.split('.')
      var fileExtension = arr[arr.length - 1].toLowerCase()
      if (fileExtension == 'pdf' || fileExtension == 'docx' || fileExtension == 'doc') {
        window.open(url, '_blank')
      } else {
        this.photoUrl = url
        this.photoShow = true
      }
    },
    writeOff(id) {
      this.$util
        .put('order/verify_codes/quick/' + id, {
          field: 'status',
          value: 1,
        })
        .then(() => {
          this.getTableData()
        })
    },
    showItemEditFunc(item, orderPayment, vcodeId = 0) {
      this.itemEditform.verify_code_id = vcodeId
      this.itemEditform.order_item_id = item.id
      this.itemEditform.order_id = item.order_id
      this.itemEditform.order_payment = orderPayment
      this.itemEditform.num = item.num
      this.itemEditform.good_id = item.good_id
      this.itemEditSearchGoods.push(item.good)
      this.itemEditform.new_payment = item.payment
      this.itemEditform.is_gift = item.is_gift

      this.showItemEdit = true
    },
    itemEditSerchFunc(type = 0) {
      if (type == 1) {
        if (!this.addItemGood.good_title) {
          this.$message('请输入增加套餐名搜索')
        }
        this.$util
          .get('good/search_goods', {
            title: this.addItemGood.good_title,
          })
          .then(res => {
            this.itemEditSearchGoods = res
          })
      } else {
        if (!this.itemEditform.good_title) {
          this.$message('请输入修改套餐名搜索')
        }
        this.$util
          .get('good/search_goods', {
            title: this.itemEditform.good_title,
          })
          .then(res => {
            this.itemEditSearchGoods = res
          })
      }
    },
    itemEditCancel() {
      this.showItemEdit = false
      this.itemEditSearchGoods = []
      this.itemEditform = {
        verify_code_id: 0,
        order_item_id: 0,
        order_id: 0,
        order_payment: 0,
        good_title: '',
        good_id: 0,
        num: 1,
        new_payment: 0,
        is_gift: 0,
      }
    },
    itemEditSubmitFunc() {
      let dialogTip = ''
      if (this.itemEditform.num <= 0) {
        dialogTip = '更改数量为0，将删除该套餐明细，是否确定继续？'
      } else {
        dialogTip = '确定更改信息？'
      }
      this.$confirm(dialogTip)
        .then(() => {
          this.$util.post('order/order_items/change_good', this.itemEditform).then(res => {
            if (res.code == 400001) {
              this.$message(res.msg)
            } else {
              this.itemEditCancel()
              this.getTableData()
            }
          })
        })
        .catch(() => {})
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          this.itemEditCancel()
          done()
        })
        .catch(() => {})
    },
    orderhandleClose(done) {
      this.$confirm('确定取消编辑订单？')
        .then(() => {
          this.resetInfo()
          this.infoShow = false
          done()
        })
        .catch(() => {})
    },
    orderPaymentEditCancel() {
      this.orderPaymentEditform.order_id = 0
      this.orderPaymentEditform.order_payment = 0
      this.orderPaymentEditform.update_item_payment = 0
      this.showOrderPaymentEdit = false
    },
    orderPaymentEditSubmitFunc() {
      this.$util.post('orders/update_payment', this.orderPaymentEditform).then(res => {
        if (res.code == 400001) {
          this.$message(res.msg)
        } else {
          this.orderPaymentEditCancel()
          this.getTableData()
        }
      })
    },
    setOrderInfo(order_id, order_item_id) {
      this.orderInfo.order_id = order_id
      this.orderInfo.order_item_id = order_item_id
    },
    getMoreCode(order_id, item_id) {
      this.setOrderInfo(order_id, item_id)
      this.showMoreCode = true
      this.batchOpenCardOrderId = order_id
      this.moreVerifyCodes = []
      this.moreCodeLoad = true
      this.checkList = []
      this.checkAll = false
      this.isIndeterminate = false
      this.$util
        .get('/merchant/order/appoint/get_more', {
          order_id: order_id,
          order_item_id: item_id,
        })
        .then(res => {
          this.moreCodeLoad = false
          this.moreVerifyCodes = res
        })
    },
    showMoreCodeClose() {
      this.showMoreCode = false
      this.moreVerifyCodes = []
      this.moreCodeLoad = false
    },
    batchOpenCard() {
      if (!this.batchChannelId) {
        this.$message('请选择开卡渠道')
        return
      }
      this.$util
        .get('orders/batchOpenCard', {
          orderId: this.batchOpenCardOrderId,
          channelId: this.batchChannelId,
        })
        .then(() => {
          this.getTableData()
        })
    },
    batchRecoveryCard() {
      this.$util
        .get('orders/batchRecoveryCard', {
          orderId: this.batchOpenCardOrderId,
          channelId: this.batchChannelId,
        })
        .then(() => {
          this.getTableData()
        })
    },
    do_export() {
      let data = this.filter
      let url = this.$util.host + '/api/order/export_all'
      let param = ''
      for (let i in data) {
        param += '&' + i + '=' + data[i]
      }
      param = param.trimLeft('&')
      url += '?' + param
      this.$confirm('若导出失败，请先选择查询条件后再导出').then(() => {
        window.open(url)
      })
    },
    importReportShow(item_id, row, n) {
      this.importReportData = {
        item_id: item_id,
        order_pretreatment_id: row.id,
        tester: row.report_tester,
        report_path: row.report_path,
        the_num: n,
      }
      if (row.report_path) {
        this.file_list.push({
          name: '报告文件',
          url: row.report_path,
        })
      }
      this.showImportReportDialog = true
    },
    importReportCancel() {
      this.importReportData = {
        item_id: 0,
        tester: '',
        report_path: '',
        the_num: 0,
      }
      this.file_list = []
      this.showImportReportDialog = false
      this.uploadReportLoading = false
    },

    uploadSuccess(response, file, fileList) {
      this.$refs.reportUpload.clearFiles()

      console.log('success', response, file, fileList)
      if (response.code != 0) {
        this.$message.error(response.msg ? response.msg : '保存失败')
        this.uploadReportLoading = false
      } else {
        this.$message.success('保存成功')
        this.importReportCancel()
        this.getTableData()
      }
    },
    uploadProgress(file) {
      console.log('progress', file)
      this.uploadReportLoading = true
    },
    handleChange(file, fileList) {
      console.log(file, fileList)
      this.file_list = fileList
    },
    handleRemove(file, fileList) {
      this.file_list = fileList
      console.log(file, fileList)
    },
    handlePreview(file) {
      if (file && file.url) {
        this.showPreview(file.url)
      }
    },
    submitUpload() {
      if (!this.importReportData.tester) {
        this.$message.error('请先输入检测人')
        return false
      }
      if (this.file_list.length <= 0) {
        this.$message.error('请先选择上传文件')
      } else {
        if (this.file_list[0].raw) {
          this.$refs.reportUpload.submit()
        } else {
          this.$util.post('order/order_items/upload_report', this.importReportData).then(res => {
            this.uploadSuccess(res, [], this.file_list)
          })
        }
      }
    },
    showAddItemGoodFunc(order_id, orderPayment, order_no) {
      this.addItemGood = {
        good_title: '',
        order_no: order_no,
        order_id: order_id,
        order_payment: orderPayment,
        good_id: '',
        num: 1,
        new_payment: 0,
        is_gift: 0,
      }
      this.showAddItemGood = true
    },
    closeAddItemGoodFunc() {
      this.itemEditSearchGoods = []
      this.addItemGood = {
        good_title: '',
        order_no: '',
        order_id: 0,
        order_payment: 0,
        good_id: '',
        num: 1,
        new_payment: 0,
        is_gift: 0,
      }
      this.showAddItemGood = false
    },
    saveAddItemGood() {
      this.saveLoading = true
      this.$confirm('确定为订单号:' + this.addItemGood.order_no + ' 增加套餐吗？').then(() => {
        this.$util.post('order/order_items', this.addItemGood).then(res => {
          this.saveLoading = false
          if (res.code != 0) {
            this.$message.error(res.msg ? res.msg : '操作失败')
          } else {
            this.closeAddItemGoodFunc()
            this.getTableData()
          }
        })
      })
    },

    getStaffs() {
      this.$util
        .get('slc', {
          model: 'Staff',
          status: 1,
        })
        .then(res => {
          this.staffs = res
        })
    },
    closeSetRefferrerFunc() {
      this.showSetReferrer = false
      this.setReferrerData = {
        order_id: 0,
        recommend_staff_id: '',
        recommend_percent: 20,
      }
    },
    showSetReferrerFunc(order) {
      this.showSetReferrer = true
      this.getStaffs()
      this.setReferrerData = {
        order_id: order.id,
        recommend_staff_id: order.recommend_staff_id ? order.recommend_staff_id : '',
        recommend_percent: order.recommend_percent,
      }
    },
    doSetRefferrerFunc() {
      if (!this.setReferrerData.recommend_staff_id) {
        this.$message.error('请选择推荐人')
      } else {
        this.saveLoading = true
        this.$confirm('保存后该推荐人将获得订单净利润的' + this.setReferrerData.recommend_percent + '%的提成，是否确定保存?')
          .then(() => {
            this.$util.post('order/recommend_staff', this.setReferrerData).then(res => {
              this.saveLoading = false
              if (res.code != 0) {
                this.$message(res.msg ? res.msg : '操作失败')
              } else {
                this.closeSetRefferrerFunc()
                this.getTableData()
              }
            })
          })
          .catch(() => {})
      }
    },
    setStatus() {
      if (this.checkOrders.length <= 0) {
        this.$message('请先选择订单')
      } else {
        this.$confirm('确定设置选择的订单为已完成吗？')
          .then(() => {
            this.$util
              .post('orders/setStatusBatch', {
                ids: this.checkOrders,
                value_data: 4,
              })
              .then(res => {
                this.saveLoading = false
                if (res.code != 0) {
                  this.$message(res.msg ? res.msg : '操作失败')
                } else {
                  this.checkOrders = []
                  this.getTableData()
                }
              })
          })
          .catch(() => {})
      }
    },
    getCascade() {
      this.$util
        .get('cascade', {
          model: 'Area',
        })
        .then(res => {
          this.areas = res
        })
    },
    getOrderItemType() {
      this.$util
        .get('slc', {
          model: 'OrderItemType',
          subitem: 1,
        })
        .then(res => {
          this.orderItemType = res
        })
    },
    changeKdName(row) {
      if (row.kd_name == '顺丰') {
        row.kd_fee = 18
      } else if (row.kd_name == '申通') {
        row.kd_fee = 1.8
      } else if (row.kd_name == '极兔') {
        row.kd_fee = 6
      } else if (row.kd_name == '韵达') {
        row.kd_fee = 0.0
      } else if (row.kd_name == '德邦') {
        row.kd_fee = 16
      } else if (row.kd_name == '邮政') {
        row.kd_fee = 15
      } else {
        row.kd_fee = 1.9
      }
    },
    change(event) {
      this.cardForm.type = event
      this.cardForm.channel_id = ''
    },
    getProvinces(level = 1) {
      this.$util
        .get('slc', {
          model: 'Area',
          level: level,
          parent_id: 0,
        })
        .then(res => {
          this.provinces = res
        })
    },
    getCities(level = 2) {
      this.$util
        .get('slc', {
          model: 'Area',
          level: level,
          parent_id: this.filter.province,
        })
        .then(res => {
          this.cities = res
        })
    },
    onEditItem(row) {
      this.saveType = 2
      this.showinfo = true
      this.info = {
        id: row.id,
        realname: row.realname,
        mobile: row.mobile,
        sex: row.sex,
        merry: row.merry,
        id_type: row.id_type,
        id_no: row.id_no,
        visit_time: row.visit_time,
        org_id: row.org_id,
        shop_id: row.shop_id,
        dispose_star: row.dispose_star,
        inoculate_org_id: row.inoculate_org_id,
      }
      this.getShops(row.id)
      this.getShops2(row.id)
    },
    infosub() {
      this.$refs['info'].validate(valid => {
        if (valid) {
          if (this.saveType == 1) {
            this.info.visit_time = this.$moment(this.info.visit_time).format('YYYY-MM-DD')
            this.$util.post('order/appointment', this.info).then(() => {
              this.getTableData()
              this.showinfo = false
            })
          } else {
            this.info.visit_time = this.$moment(this.info.visit_time).format('YYYY-MM-DD')
            this.$util.put('order/appointment/' + this.info.id, this.info).then(res => {
              if (res.code == 0) {
                this.getTableData()
                this.showinfo = false
              } else {
                this.$message(res.msg ? res.msg : '操作失败')
              }
            })
          }
        } else {
          return false
        }
      })
    },
    handleCheckAllChange(val) {
      const all = this.moreVerifyCodes.list.map(verify => {
        return verify.id
      })
      this.checkList = val ? all : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.moreVerifyCodes.list.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.moreVerifyCodes.list.length
    },
    orderPretreatment() {
      this.$util
        .put('/merchant/order/appoint/batch_audit', {
          ids: this.checkList,
        })
        .then(() => {
          this.getTableData()
        })
    },
    updateDate() {
      this.$util
        .put('/merchant/order/appoint/batch_time', {
          ids: this.checkList,
          time: this.datevalue,
        })
        .then(() => {
          this.getTableData()
        })
    },
    save() {
      this.getTableData()
    },
    dateChange(value) {
      if (value) {
        this.info.period_start = value[0]
        this.info.period_end = value[1]
      } else {
        this.info.period_start = ''
        this.info.period_end = ''
      }
    },
    updateKd() {
      this.updateKdInfo.ids = this.checkList
      this.updateKdShow = true
    },
    closeUpdateKsInfo() {
      this.updateKdInfo = {
        ids: [],
        kd_no: '',
      }
      this.updateKdShow = false
    },
    subUpdateKsInfo() {
      this.$util.post('order/order_pretreatment/batch_edit_kdno', this.updateKdInfo).then(res => {
        if (res.code == 0) {
          this.getGoodsByShippingStatus(this.orderInfo).then(res => {
            this.moreVerifyCodes.list = res.list
            this.updateKdShow = false
          })
        } else {
          this.$message(res.msg)
        }
      })
    },
    async getGoodsByShippingStatus(query) {
      const orderInfo = await this.$util.get('order/order_pretreatment/get_more_shipping', query).then(res => res)
      return orderInfo
    },
  },

  watch: {
    $route(to) {
      if (to.query.keyword && to.name == 'order_all') {
        this.filter.keyword = to.query.keyword
        this.getTableData()
      } else if (to.query.member_id && to.name == 'order_all') {
        this.filter.member_id = to.query.member_id
        this.getTableData()
      }
    },
  },
}
</script>

<style scoped>
.page {
  margin: 0;
  padding: 0;
}

.order_table {
  width: 95%;
}

.order {
  color: #333;
  font-size: 12px;
  margin-bottom: 20px;
  border: #dcdfe6 1px solid;
}

.order-no span {
  margin-right: 10px;
}

.order-header {
  background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.good-title {
  font-size: 14px;
  color: #363636;
}

.order-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.order-operation {
  width: 165px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.order-items {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid #dcdfe6;
}

.kd_info {
  padding: 10px;
  border-right: #dcdfe6 1px solid;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.membermsg {
  padding-left: 10px;
  font-size: 14px;
  line-height: 20px;
  font-family: PingFang SC;
  color: #363636;
  width: 450px;
}

.member {
  display: flex;
  flex-direction: column;
}

.star {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.star .el-button {
  margin: 10px;
}

.order-money {
  width: 120px;
  display: flex;
  margin-bottom: 10px;
  flex-direction: column;
  justify-content: center;
}

.order-time {
  width: 200px;
  padding: 10px;
  border-right: #dcdfe6 1px solid;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.order-item {
  border-bottom: #dcdfe6 1px solid;
}

.order-item:last-child {
  border-bottom: none;
}

.good {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
}

.good-img {
  width: 130px;
  padding: 10px;
  height: 130px;
  margin: 0px;
}

.good-info {
  padding: 10px;
  width: 250px;
}

.good-verifies {
  display: flex;
  flex-direction: column;
  border-left: 1px solid #dcdfe6;
  width: 90%;
}

.verify {
  height: 100%;
  border-bottom: 1px solid #dcdfe6;
}

.verify-body {
  vertical-align: top;
  display: inline-block;
  line-height: 25px;
  font-size: 14px;
  width: 45%;
  padding: 10px;
  height: 100%;
}

.verify-body:last-child {
  border-bottom: none;
}

.wrap2 {
  border-left: 1px solid #dcdfe6;
}

.good-verifies .verify:last-child {
  border-bottom: none;
}

.num {
  display: block;
}

.verify span {
  margin-right: 10px;
}

.verify-header {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.verify-multiple {
  margin-bottom: 10px;
}

.row-edit-input {
  margin-bottom: 10px;
}

.order-item-extend {
  padding: 10px;
}

.quick-form {
  margin-bottom: 10px;
}

.el-button-group + .el-button-group {
  margin-left: 10px;
}

.el-link + .el-link {
  margin-left: 10px;
}

.el-tag--dark {
  border: none;
}

.flex {
  display: flex;
  align-items: center;
}

.photo {
  width: 300px;
}

.good-box {
  display: flex;
  flex-wrap: wrap;
  width: 450px;
  justify-content: space-between;
  padding: 10px;
}

.verify_child {
  width: 1000px !important;
  margin-top: 10px;
  padding-bottom: 10px;
}

.verify_child > div {
  width: 30%;
  display: inline-block;
  vertical-align: top;
}

.ispay {
  font-size: 14px;
  line-height: 20px;
  color: #363636;
  font-family: PingFang SC;
  margin-top: 50px;
}

.editbtn {
  float: right;
  overflow: hidden;
  margin-right: 15px;
  cursor: pointer;
}

.btngroup {
  float: right;
  display: flex;
}

.btn-bottom {
  float: right;
  width: 60px;
  margin: -65px 0 0 110px;
}

.order-payment {
  margin-top: 20px;
}

.payment {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 20px;
  font-size: 14px;
  font-family: PingFang SC;
  color: #363636;
}

.paymentbtn {
  padding: 10px 0 0 10px;
}

.speed,
.speeds {
  width: 60px;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  margin: 0 auto;
  background: #ecf5ff;
  border-radius: 4px;
}

.speeds {
  color: #fff;
  background: #007cff;
}

.play {
  white-space: nowrap;
  background: white;
  border: 1px solid #dcdfe6;
  font-weight: 500;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  position: relative;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  padding: 0 20px;
  font-size: 14px;
  border-radius: 4px;
  display: inline-block;
  width: 156px;
  height: 40px;
  line-height: 40px;
  top: -13px;
  z-index: -1;
}

.moreCode {
  color: #999da0;
  text-align: center;
  font-size: 14px;
  height: 20px;
  padding: 5px;
  text-decoration: underline;
  cursor: pointer;
}
</style>
